function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _get__("_defineProperties")(Constructor.prototype, protoProps);
  if (staticProps) _get__("_defineProperties")(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */


var MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var CREATED = 1;
var MOUNTED = 2;
var IDLE = 3;
var MOVING = 4;
var SCROLLING = 5;
var DRAGGING = 6;
var DESTROYED = 7;
var STATES = {
  CREATED: _get__("CREATED"),
  MOUNTED: _get__("MOUNTED"),
  IDLE: _get__("IDLE"),
  MOVING: _get__("MOVING"),
  SCROLLING: _get__("SCROLLING"),
  DRAGGING: _get__("DRAGGING"),
  DESTROYED: _get__("DESTROYED")
};

function empty(array) {
  array.length = 0;
}

function slice(arrayLike, start, end) {
  return Array.prototype.slice.call(arrayLike, start, end);
}

function apply(func) {
  return func.bind.apply(func, [null].concat(_get__("slice")(arguments, 1)));
}

var nextTick = setTimeout;

var noop = function noop() {};

function raf(func) {
  return requestAnimationFrame(func);
}

function typeOf(type, subject) {
  return _typeof(subject) === type;
}

function isObject(subject) {
  return !_get__("isNull")(subject) && _get__("typeOf")("object", subject);
}

var isArray = Array.isArray;

var isFunction = _get__("apply")(_get__("typeOf"), "function");

var isString = _get__("apply")(_get__("typeOf"), "string");

var isUndefined = _get__("apply")(_get__("typeOf"), "undefined");

function isNull(subject) {
  return subject === null;
}

function isHTMLElement(subject) {
  try {
    return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
  } catch (e) {
    return false;
  }
}

function toArray(value) {
  return _get__("isArray")(value) ? value : [value];
}

function forEach(values, iteratee) {
  _get__("toArray")(values).forEach(iteratee);
}

function includes(array, value) {
  return array.indexOf(value) > -1;
}

function push(array, items) {
  array.push.apply(array, _get__("toArray")(items));
  return array;
}

function toggleClass(elm, classes, add) {
  if (elm) {
    _get__("forEach")(classes, function (name) {
      if (name) {
        elm.classList[add ? "add" : "remove"](name);
      }
    });
  }
}

function addClass(elm, classes) {
  _get__("toggleClass")(elm, _get__("isString")(classes) ? classes.split(" ") : classes, true);
}

function append(parent, children) {
  _get__("forEach")(children, parent.appendChild.bind(parent));
}

function before(nodes, ref) {
  _get__("forEach")(nodes, function (node) {
    var parent = (ref || node).parentNode;

    if (parent) {
      parent.insertBefore(node, ref);
    }
  });
}

function matches(elm, selector) {
  return _get__("isHTMLElement")(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}

function children(parent, selector) {
  var children2 = parent ? _get__("slice")(parent.children) : [];
  return selector ? children2.filter(function (child) {
    return _get__("matches")(child, selector);
  }) : children2;
}

function child(parent, selector) {
  return selector ? _get__("children")(parent, selector)[0] : parent.firstElementChild;
}

var ownKeys = Object.keys;

function forOwn(object, iteratee, right) {
  if (object) {
    (right ? _get__("ownKeys")(object).reverse() : _get__("ownKeys")(object)).forEach(function (key) {
      key !== "__proto__" && iteratee(object[key], key);
    });
  }

  return object;
}

function assign(object) {
  _get__("slice")(arguments, 1).forEach(function (source) {
    _get__("forOwn")(source, function (value, key) {
      object[key] = source[key];
    });
  });

  return object;
}

function merge(object) {
  _get__("slice")(arguments, 1).forEach(function (source) {
    _get__("forOwn")(source, function (value, key) {
      if (_get__("isArray")(value)) {
        object[key] = value.slice();
      } else if (_get__("isObject")(value)) {
        object[key] = _get__("merge")({}, _get__("isObject")(object[key]) ? object[key] : {}, value);
      } else {
        object[key] = value;
      }
    });
  });

  return object;
}

function omit(object, keys) {
  _get__("forEach")(keys || _get__("ownKeys")(object), function (key) {
    delete object[key];
  });
}

function removeAttribute(elms, attrs) {
  _get__("forEach")(elms, function (elm) {
    _get__("forEach")(attrs, function (attr) {
      elm && elm.removeAttribute(attr);
    });
  });
}

function setAttribute(elms, attrs, value) {
  if (_get__("isObject")(attrs)) {
    _get__("forOwn")(attrs, function (value2, name) {
      _get__("setAttribute")(elms, name, value2);
    });
  } else {
    _get__("forEach")(elms, function (elm) {
      _get__("isNull")(value) || value === "" ? _get__("removeAttribute")(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
  }
}

function create(tag, attrs, parent) {
  var elm = document.createElement(tag);

  if (attrs) {
    _get__("isString")(attrs) ? _get__("addClass")(elm, attrs) : _get__("setAttribute")(elm, attrs);
  }

  parent && _get__("append")(parent, elm);
  return elm;
}

function style(elm, prop, value) {
  if (_get__("isUndefined")(value)) {
    return getComputedStyle(elm)[prop];
  }

  if (!_get__("isNull")(value)) {
    elm.style[prop] = "" + value;
  }
}

function display(elm, display2) {
  _get__("style")(elm, "display", display2);
}

function focus(elm) {
  elm["setActive"] && elm["setActive"]() || elm.focus({
    preventScroll: true
  });
}

function getAttribute(elm, attr) {
  return elm.getAttribute(attr);
}

function hasClass(elm, className) {
  return elm && elm.classList.contains(className);
}

function rect(target) {
  return target.getBoundingClientRect();
}

function remove(nodes) {
  _get__("forEach")(nodes, function (node) {
    if (node && node.parentNode) {
      node.parentNode.removeChild(node);
    }
  });
}

function parseHtml(html) {
  return _get__("child")(new DOMParser().parseFromString(html, "text/html").body);
}

function prevent(e, stopPropagation) {
  e.preventDefault();

  if (stopPropagation) {
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
}

function query(parent, selector) {
  return parent && parent.querySelector(selector);
}

function queryAll(parent, selector) {
  return selector ? _get__("slice")(parent.querySelectorAll(selector)) : [];
}

function removeClass(elm, classes) {
  _get__("toggleClass")(elm, classes, false);
}

function timeOf(e) {
  return e.timeStamp;
}

function unit(value) {
  return _get__("isString")(value) ? value : value ? value + "px" : "";
}

var PROJECT_CODE = "splide";

var DATA_ATTRIBUTE = "data-" + _get__("PROJECT_CODE");

function assert(condition, message) {
  if (!condition) {
    throw new Error("[" + _get__("PROJECT_CODE") + "] " + (message || ""));
  }
}

var min = Math.min,
    max = Math.max,
    floor = Math.floor,
    ceil = Math.ceil,
    abs = Math.abs;

function approximatelyEqual(x, y, epsilon) {
  return _get__("abs")(x - y) < epsilon;
}

function between(number, x, y, exclusive) {
  var minimum = _get__("min")(x, y);

  var maximum = _get__("max")(x, y);

  return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}

function clamp(number, x, y) {
  var minimum = _get__("min")(x, y);

  var maximum = _get__("max")(x, y);

  return _get__("min")(_get__("max")(minimum, number), maximum);
}

function sign(x) {
  return +(x > 0) - +(x < 0);
}

function camelToKebab(string) {
  return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

function format(string, replacements) {
  _get__("forEach")(replacements, function (replacement) {
    string = string.replace("%s", "" + replacement);
  });

  return string;
}

function pad(number) {
  return number < 10 ? "0" + number : "" + number;
}

var ids = {};

function uniqueId(prefix) {
  return "" + prefix + _get__("pad")(_get__("ids")[prefix] = (_get__("ids")[prefix] || 0) + 1);
}

function EventBinder() {
  var listeners = [];

  function bind(targets, events, callback, options) {
    forEachEvent(targets, events, function (target, event, namespace) {
      var isEventTarget = "addEventListener" in target;
      var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
      isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
      listeners.push([target, event, namespace, callback, remover]);
    });
  }

  function unbind(targets, events, callback) {
    forEachEvent(targets, events, function (target, event, namespace) {
      listeners = listeners.filter(function (listener) {
        if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
          listener[4]();
          return false;
        }

        return true;
      });
    });
  }

  function dispatch(target, type, detail) {
    var e;
    var bubbles = true;

    if (typeof CustomEvent === "function") {
      e = new CustomEvent(type, {
        bubbles: bubbles,
        detail: detail
      });
    } else {
      e = document.createEvent("CustomEvent");
      e.initCustomEvent(type, bubbles, false, detail);
    }

    target.dispatchEvent(e);
    return e;
  }

  function forEachEvent(targets, events, iteratee) {
    _get__("forEach")(targets, function (target) {
      target && _get__("forEach")(events, function (events2) {
        events2.split(" ").forEach(function (eventNS) {
          var fragment = eventNS.split(".");
          iteratee(target, fragment[0], fragment[1]);
        });
      });
    });
  }

  function destroy() {
    listeners.forEach(function (data) {
      data[4]();
    });

    _get__("empty")(listeners);
  }

  return {
    bind: bind,
    unbind: unbind,
    dispatch: dispatch,
    destroy: destroy
  };
}

var EVENT_MOUNTED = "mounted";
var EVENT_READY = "ready";
var EVENT_MOVE = "move";
var EVENT_MOVED = "moved";
var EVENT_CLICK = "click";
var EVENT_ACTIVE = "active";
var EVENT_INACTIVE = "inactive";
var EVENT_VISIBLE = "visible";
var EVENT_HIDDEN = "hidden";
var EVENT_REFRESH = "refresh";
var EVENT_UPDATED = "updated";
var EVENT_RESIZE = "resize";
var EVENT_RESIZED = "resized";
var EVENT_DRAG = "drag";
var EVENT_DRAGGING = "dragging";
var EVENT_DRAGGED = "dragged";
var EVENT_SCROLL = "scroll";
var EVENT_SCROLLED = "scrolled";
var EVENT_OVERFLOW = "overflow";
var EVENT_DESTROY = "destroy";
var EVENT_ARROWS_MOUNTED = "arrows:mounted";
var EVENT_ARROWS_UPDATED = "arrows:updated";
var EVENT_PAGINATION_MOUNTED = "pagination:mounted";
var EVENT_PAGINATION_UPDATED = "pagination:updated";
var EVENT_NAVIGATION_MOUNTED = "navigation:mounted";
var EVENT_AUTOPLAY_PLAY = "autoplay:play";
var EVENT_AUTOPLAY_PLAYING = "autoplay:playing";
var EVENT_AUTOPLAY_PAUSE = "autoplay:pause";
var EVENT_LAZYLOAD_LOADED = "lazyload:loaded";
var EVENT_SLIDE_KEYDOWN = "sk";
var EVENT_SHIFTED = "sh";
var EVENT_END_INDEX_CHANGED = "ei";

function EventInterface(Splide2) {
  var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();

  var binder = _get__("EventBinder")();

  function on(events, callback) {
    binder.bind(bus, _get__("toArray")(events).join(" "), function (e) {
      callback.apply(callback, _get__("isArray")(e.detail) ? e.detail : []);
    });
  }

  function emit(event) {
    binder.dispatch(bus, event, _get__("slice")(arguments, 1));
  }

  if (Splide2) {
    Splide2.event.on(_get__("EVENT_DESTROY"), binder.destroy);
  }

  return _get__("assign")(binder, {
    bus: bus,
    on: on,
    off: _get__("apply")(binder.unbind, bus),
    emit: emit
  });
}

function RequestInterval(interval, onInterval, onUpdate, limit) {
  var now = Date.now;
  var startTime;
  var rate = 0;
  var id;
  var paused = true;
  var count = 0;

  function update() {
    if (!paused) {
      rate = interval ? _get__("min")((now() - startTime) / interval, 1) : 1;
      onUpdate && onUpdate(rate);

      if (rate >= 1) {
        onInterval();
        startTime = now();

        if (limit && ++count >= limit) {
          return pause();
        }
      }

      id = _get__("raf")(update);
    }
  }

  function start(resume) {
    resume || cancel();
    startTime = now() - (resume ? rate * interval : 0);
    paused = false;
    id = _get__("raf")(update);
  }

  function pause() {
    paused = true;
  }

  function rewind() {
    startTime = now();
    rate = 0;

    if (onUpdate) {
      onUpdate(rate);
    }
  }

  function cancel() {
    id && cancelAnimationFrame(id);
    rate = 0;
    id = 0;
    paused = true;
  }

  function set(time) {
    interval = time;
  }

  function isPaused() {
    return paused;
  }

  return {
    start: start,
    rewind: rewind,
    pause: pause,
    cancel: cancel,
    set: set,
    isPaused: isPaused
  };
}

function State(initialState) {
  var state = initialState;

  function set(value) {
    state = value;
  }

  function is(states) {
    return _get__("includes")(_get__("toArray")(states), state);
  }

  return {
    set: set,
    is: is
  };
}

function Throttle(func, duration) {
  var interval = _get__("RequestInterval")(duration || 0, func, null, 1);

  return function () {
    interval.isPaused() && interval.start();
  };
}

function Media(Splide2, Components2, options) {
  var state = Splide2.state;
  var breakpoints = options.breakpoints || {};
  var reducedMotion = options.reducedMotion || {};

  var binder = _get__("EventBinder")();

  var queries = [];

  function setup() {
    var isMin = options.mediaQuery === "min";

    _get__("ownKeys")(breakpoints).sort(function (n, m) {
      return isMin ? +n - +m : +m - +n;
    }).forEach(function (key) {
      register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
    });

    register(reducedMotion, _get__("MEDIA_PREFERS_REDUCED_MOTION"));
    update();
  }

  function destroy(completely) {
    if (completely) {
      binder.destroy();
    }
  }

  function register(options2, query) {
    var queryList = matchMedia(query);
    binder.bind(queryList, "change", update);
    queries.push([options2, queryList]);
  }

  function update() {
    var destroyed = state.is(_get__("DESTROYED"));
    var direction = options.direction;
    var merged = queries.reduce(function (merged2, entry) {
      return _get__("merge")(merged2, entry[1].matches ? entry[0] : {});
    }, {});

    _get__("omit")(options);

    set(merged);

    if (options.destroy) {
      Splide2.destroy(options.destroy === "completely");
    } else if (destroyed) {
      destroy(true);
      Splide2.mount();
    } else {
      direction !== options.direction && Splide2.refresh();
    }
  }

  function reduce(enable) {
    if (matchMedia(_get__("MEDIA_PREFERS_REDUCED_MOTION")).matches) {
      enable ? _get__("merge")(options, reducedMotion) : _get__("omit")(options, _get__("ownKeys")(reducedMotion));
    }
  }

  function set(opts, base, notify) {
    _get__("merge")(options, opts);

    base && _get__("merge")(Object.getPrototypeOf(options), opts);

    if (notify || !state.is(_get__("CREATED"))) {
      Splide2.emit(_get__("EVENT_UPDATED"), options);
    }
  }

  return {
    setup: setup,
    destroy: destroy,
    reduce: reduce,
    set: set
  };
}

var ARROW = "Arrow";
var ARROW_LEFT = _get__("ARROW") + "Left";
var ARROW_RIGHT = _get__("ARROW") + "Right";
var ARROW_UP = _get__("ARROW") + "Up";
var ARROW_DOWN = _get__("ARROW") + "Down";
var LTR = "ltr";
var RTL = "rtl";
var TTB = "ttb";
var ORIENTATION_MAP = {
  width: ["height"],
  left: ["top", "right"],
  right: ["bottom", "left"],
  x: ["y"],
  X: ["Y"],
  Y: ["X"],
  ArrowLeft: [_get__("ARROW_UP"), _get__("ARROW_RIGHT")],
  ArrowRight: [_get__("ARROW_DOWN"), _get__("ARROW_LEFT")]
};

function Direction(Splide2, Components2, options) {
  function resolve(prop, axisOnly, direction) {
    direction = direction || options.direction;
    var index = direction === _get__("RTL") && !axisOnly ? 1 : direction === _get__("TTB") ? 0 : -1;
    return _get__("ORIENTATION_MAP")[prop] && _get__("ORIENTATION_MAP")[prop][index] || prop.replace(/width|left|right/i, function (match, offset) {
      var replacement = _get__("ORIENTATION_MAP")[match.toLowerCase()][index] || match;
      return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
    });
  }

  function orient(value) {
    return value * (options.direction === _get__("RTL") ? 1 : -1);
  }

  return {
    resolve: resolve,
    orient: orient
  };
}

var ROLE = "role";
var TAB_INDEX = "tabindex";
var DISABLED = "disabled";
var ARIA_PREFIX = "aria-";
var ARIA_CONTROLS = _get__("ARIA_PREFIX") + "controls";
var ARIA_CURRENT = _get__("ARIA_PREFIX") + "current";
var ARIA_SELECTED = _get__("ARIA_PREFIX") + "selected";
var ARIA_LABEL = _get__("ARIA_PREFIX") + "label";
var ARIA_LABELLEDBY = _get__("ARIA_PREFIX") + "labelledby";
var ARIA_HIDDEN = _get__("ARIA_PREFIX") + "hidden";
var ARIA_ORIENTATION = _get__("ARIA_PREFIX") + "orientation";
var ARIA_ROLEDESCRIPTION = _get__("ARIA_PREFIX") + "roledescription";
var ARIA_LIVE = _get__("ARIA_PREFIX") + "live";
var ARIA_BUSY = _get__("ARIA_PREFIX") + "busy";
var ARIA_ATOMIC = _get__("ARIA_PREFIX") + "atomic";
var ALL_ATTRIBUTES = [_get__("ROLE"), _get__("TAB_INDEX"), _get__("DISABLED"), _get__("ARIA_CONTROLS"), _get__("ARIA_CURRENT"), _get__("ARIA_LABEL"), _get__("ARIA_LABELLEDBY"), _get__("ARIA_HIDDEN"), _get__("ARIA_ORIENTATION"), _get__("ARIA_ROLEDESCRIPTION")];
var CLASS_PREFIX = _get__("PROJECT_CODE") + "__";
var STATUS_CLASS_PREFIX = "is-";

var CLASS_ROOT = _get__("PROJECT_CODE");

var CLASS_TRACK = _get__("CLASS_PREFIX") + "track";
var CLASS_LIST = _get__("CLASS_PREFIX") + "list";
var CLASS_SLIDE = _get__("CLASS_PREFIX") + "slide";
var CLASS_CLONE = _get__("CLASS_SLIDE") + "--clone";
var CLASS_CONTAINER = _get__("CLASS_SLIDE") + "__container";
var CLASS_ARROWS = _get__("CLASS_PREFIX") + "arrows";
var CLASS_ARROW = _get__("CLASS_PREFIX") + "arrow";
var CLASS_ARROW_PREV = _get__("CLASS_ARROW") + "--prev";
var CLASS_ARROW_NEXT = _get__("CLASS_ARROW") + "--next";
var CLASS_PAGINATION = _get__("CLASS_PREFIX") + "pagination";
var CLASS_PAGINATION_PAGE = _get__("CLASS_PAGINATION") + "__page";
var CLASS_PROGRESS = _get__("CLASS_PREFIX") + "progress";
var CLASS_PROGRESS_BAR = _get__("CLASS_PROGRESS") + "__bar";
var CLASS_TOGGLE = _get__("CLASS_PREFIX") + "toggle";
var CLASS_TOGGLE_PLAY = _get__("CLASS_TOGGLE") + "__play";
var CLASS_TOGGLE_PAUSE = _get__("CLASS_TOGGLE") + "__pause";
var CLASS_SPINNER = _get__("CLASS_PREFIX") + "spinner";
var CLASS_SR = _get__("CLASS_PREFIX") + "sr";
var CLASS_INITIALIZED = _get__("STATUS_CLASS_PREFIX") + "initialized";
var CLASS_ACTIVE = _get__("STATUS_CLASS_PREFIX") + "active";
var CLASS_PREV = _get__("STATUS_CLASS_PREFIX") + "prev";
var CLASS_NEXT = _get__("STATUS_CLASS_PREFIX") + "next";
var CLASS_VISIBLE = _get__("STATUS_CLASS_PREFIX") + "visible";
var CLASS_LOADING = _get__("STATUS_CLASS_PREFIX") + "loading";
var CLASS_FOCUS_IN = _get__("STATUS_CLASS_PREFIX") + "focus-in";
var CLASS_OVERFLOW = _get__("STATUS_CLASS_PREFIX") + "overflow";
var STATUS_CLASSES = [_get__("CLASS_ACTIVE"), _get__("CLASS_VISIBLE"), _get__("CLASS_PREV"), _get__("CLASS_NEXT"), _get__("CLASS_LOADING"), _get__("CLASS_FOCUS_IN"), _get__("CLASS_OVERFLOW")];
var CLASSES = {
  slide: _get__("CLASS_SLIDE"),
  clone: _get__("CLASS_CLONE"),
  arrows: _get__("CLASS_ARROWS"),
  arrow: _get__("CLASS_ARROW"),
  prev: _get__("CLASS_ARROW_PREV"),
  next: _get__("CLASS_ARROW_NEXT"),
  pagination: _get__("CLASS_PAGINATION"),
  page: _get__("CLASS_PAGINATION_PAGE"),
  spinner: _get__("CLASS_SPINNER")
};

function closest(from, selector) {
  if (_get__("isFunction")(from.closest)) {
    return from.closest(selector);
  }

  var elm = from;

  while (elm && elm.nodeType === 1) {
    if (_get__("matches")(elm, selector)) {
      break;
    }

    elm = elm.parentElement;
  }

  return elm;
}

var FRICTION = 5;
var LOG_INTERVAL = 200;
var POINTER_DOWN_EVENTS = "touchstart mousedown";
var POINTER_MOVE_EVENTS = "touchmove mousemove";
var POINTER_UP_EVENTS = "touchend touchcancel mouseup click";

function Elements(Splide2, Components2, options) {
  var _EventInterface = _get__("EventInterface")(Splide2),
      on = _EventInterface.on,
      bind = _EventInterface.bind;

  var root = Splide2.root;
  var i18n = options.i18n;
  var elements = {};
  var slides = [];
  var rootClasses = [];
  var trackClasses = [];
  var track;
  var list;
  var isUsingKey;

  function setup() {
    collect();
    init();
    update();
  }

  function mount() {
    on(_get__("EVENT_REFRESH"), destroy);
    on(_get__("EVENT_REFRESH"), setup);
    on(_get__("EVENT_UPDATED"), update);
    bind(document, _get__("POINTER_DOWN_EVENTS") + " keydown", function (e) {
      isUsingKey = e.type === "keydown";
    }, {
      capture: true
    });
    bind(root, "focusin", function () {
      _get__("toggleClass")(root, _get__("CLASS_FOCUS_IN"), !!isUsingKey);
    });
  }

  function destroy(completely) {
    var attrs = _get__("ALL_ATTRIBUTES").concat("style");

    _get__("empty")(slides);

    _get__("removeClass")(root, rootClasses);

    _get__("removeClass")(track, trackClasses);

    _get__("removeAttribute")([track, list], attrs);

    _get__("removeAttribute")(root, completely ? attrs : ["style", _get__("ARIA_ROLEDESCRIPTION")]);
  }

  function update() {
    _get__("removeClass")(root, rootClasses);

    _get__("removeClass")(track, trackClasses);

    rootClasses = getClasses(_get__("CLASS_ROOT"));
    trackClasses = getClasses(_get__("CLASS_TRACK"));

    _get__("addClass")(root, rootClasses);

    _get__("addClass")(track, trackClasses);

    _get__("setAttribute")(root, _get__("ARIA_LABEL"), options.label);

    _get__("setAttribute")(root, _get__("ARIA_LABELLEDBY"), options.labelledby);
  }

  function collect() {
    track = find("." + _get__("CLASS_TRACK"));
    list = _get__("child")(track, "." + _get__("CLASS_LIST"));

    _get__("assert")(track && list, "A track/list element is missing.");

    _get__("push")(slides, _get__("children")(list, "." + _get__("CLASS_SLIDE") + ":not(." + _get__("CLASS_CLONE") + ")"));

    _get__("forOwn")({
      arrows: _get__("CLASS_ARROWS"),
      pagination: _get__("CLASS_PAGINATION"),
      prev: _get__("CLASS_ARROW_PREV"),
      next: _get__("CLASS_ARROW_NEXT"),
      bar: _get__("CLASS_PROGRESS_BAR"),
      toggle: _get__("CLASS_TOGGLE")
    }, function (className, key) {
      elements[key] = find("." + className);
    });

    _get__("assign")(elements, {
      root: root,
      track: track,
      list: list,
      slides: slides
    });
  }

  function init() {
    var id = root.id || _get__("uniqueId")(_get__("PROJECT_CODE"));

    var role = options.role;
    root.id = id;
    track.id = track.id || id + "-track";
    list.id = list.id || id + "-list";

    if (!_get__("getAttribute")(root, _get__("ROLE")) && root.tagName !== "SECTION" && role) {
      _get__("setAttribute")(root, _get__("ROLE"), role);
    }

    _get__("setAttribute")(root, _get__("ARIA_ROLEDESCRIPTION"), i18n.carousel);

    _get__("setAttribute")(list, _get__("ROLE"), "presentation");
  }

  function find(selector) {
    var elm = _get__("query")(root, selector);

    return elm && _get__("closest")(elm, "." + _get__("CLASS_ROOT")) === root ? elm : void 0;
  }

  function getClasses(base) {
    return [base + "--" + options.type, base + "--" + options.direction, options.drag && base + "--draggable", options.isNavigation && base + "--nav", base === _get__("CLASS_ROOT") && _get__("CLASS_ACTIVE")];
  }

  return _get__("assign")(elements, {
    setup: setup,
    mount: mount,
    destroy: destroy
  });
}

var SLIDE = "slide";
var LOOP = "loop";
var FADE = "fade";

function Slide$1(Splide2, index, slideIndex, slide) {
  var event = _get__("EventInterface")(Splide2);

  var on = event.on,
      emit = event.emit,
      bind = event.bind;
  var Components = Splide2.Components,
      root = Splide2.root,
      options = Splide2.options;
  var isNavigation = options.isNavigation,
      updateOnMove = options.updateOnMove,
      i18n = options.i18n,
      pagination = options.pagination,
      slideFocus = options.slideFocus;
  var resolve = Components.Direction.resolve;

  var styles = _get__("getAttribute")(slide, "style");

  var label = _get__("getAttribute")(slide, _get__("ARIA_LABEL"));

  var isClone = slideIndex > -1;

  var container = _get__("child")(slide, "." + _get__("CLASS_CONTAINER"));

  var destroyed;

  function mount() {
    if (!isClone) {
      slide.id = root.id + "-slide" + _get__("pad")(index + 1);

      _get__("setAttribute")(slide, _get__("ROLE"), pagination ? "tabpanel" : "group");

      _get__("setAttribute")(slide, _get__("ARIA_ROLEDESCRIPTION"), i18n.slide);

      _get__("setAttribute")(slide, _get__("ARIA_LABEL"), label || _get__("format")(i18n.slideLabel, [index + 1, Splide2.length]));
    }

    listen();
  }

  function listen() {
    bind(slide, "click", _get__("apply")(emit, _get__("EVENT_CLICK"), self));
    bind(slide, "keydown", _get__("apply")(emit, _get__("EVENT_SLIDE_KEYDOWN"), self));
    on([_get__("EVENT_MOVED"), _get__("EVENT_SHIFTED"), _get__("EVENT_SCROLLED")], update);
    on(_get__("EVENT_NAVIGATION_MOUNTED"), initNavigation);

    if (updateOnMove) {
      on(_get__("EVENT_MOVE"), onMove);
    }
  }

  function destroy() {
    destroyed = true;
    event.destroy();

    _get__("removeClass")(slide, _get__("STATUS_CLASSES"));

    _get__("removeAttribute")(slide, _get__("ALL_ATTRIBUTES"));

    _get__("setAttribute")(slide, "style", styles);

    _get__("setAttribute")(slide, _get__("ARIA_LABEL"), label || "");
  }

  function initNavigation() {
    var controls = Splide2.splides.map(function (target) {
      var Slide2 = target.splide.Components.Slides.getAt(index);
      return Slide2 ? Slide2.slide.id : "";
    }).join(" ");

    _get__("setAttribute")(slide, _get__("ARIA_LABEL"), _get__("format")(i18n.slideX, (isClone ? slideIndex : index) + 1));

    _get__("setAttribute")(slide, _get__("ARIA_CONTROLS"), controls);

    _get__("setAttribute")(slide, _get__("ROLE"), slideFocus ? "button" : "");

    slideFocus && _get__("removeAttribute")(slide, _get__("ARIA_ROLEDESCRIPTION"));
  }

  function onMove() {
    if (!destroyed) {
      update();
    }
  }

  function update() {
    if (!destroyed) {
      var curr = Splide2.index;
      updateActivity();
      updateVisibility();

      _get__("toggleClass")(slide, _get__("CLASS_PREV"), index === curr - 1);

      _get__("toggleClass")(slide, _get__("CLASS_NEXT"), index === curr + 1);
    }
  }

  function updateActivity() {
    var active = isActive();

    if (active !== _get__("hasClass")(slide, _get__("CLASS_ACTIVE"))) {
      _get__("toggleClass")(slide, _get__("CLASS_ACTIVE"), active);

      _get__("setAttribute")(slide, _get__("ARIA_CURRENT"), isNavigation && active || "");

      emit(active ? _get__("EVENT_ACTIVE") : _get__("EVENT_INACTIVE"), self);
    }
  }

  function updateVisibility() {
    var visible = isVisible();
    var hidden = !visible && (!isActive() || isClone);

    if (!Splide2.state.is([_get__("MOVING"), _get__("SCROLLING")])) {
      _get__("setAttribute")(slide, _get__("ARIA_HIDDEN"), hidden || "");
    }

    _get__("setAttribute")(_get__("queryAll")(slide, options.focusableNodes || ""), _get__("TAB_INDEX"), hidden ? -1 : "");

    if (slideFocus) {
      _get__("setAttribute")(slide, _get__("TAB_INDEX"), hidden ? -1 : 0);
    }

    if (visible !== _get__("hasClass")(slide, _get__("CLASS_VISIBLE"))) {
      _get__("toggleClass")(slide, _get__("CLASS_VISIBLE"), visible);

      emit(visible ? _get__("EVENT_VISIBLE") : _get__("EVENT_HIDDEN"), self);
    }

    if (!visible && document.activeElement === slide) {
      var Slide2 = Components.Slides.getAt(Splide2.index);
      Slide2 && _get__("focus")(Slide2.slide);
    }
  }

  function style$1(prop, value, useContainer) {
    _get__("style")(useContainer && container || slide, prop, value);
  }

  function isActive() {
    var curr = Splide2.index;
    return curr === index || options.cloneStatus && curr === slideIndex;
  }

  function isVisible() {
    if (Splide2.is(_get__("FADE"))) {
      return isActive();
    }

    var trackRect = _get__("rect")(Components.Elements.track);

    var slideRect = _get__("rect")(slide);

    var left = resolve("left", true);
    var right = resolve("right", true);
    return _get__("floor")(trackRect[left]) <= _get__("ceil")(slideRect[left]) && _get__("floor")(slideRect[right]) <= _get__("ceil")(trackRect[right]);
  }

  function isWithin(from, distance) {
    var diff = _get__("abs")(from - index);

    if (!isClone && (options.rewind || Splide2.is(_get__("LOOP")))) {
      diff = _get__("min")(diff, Splide2.length - diff);
    }

    return diff <= distance;
  }

  var self = {
    index: index,
    slideIndex: slideIndex,
    slide: slide,
    container: container,
    isClone: isClone,
    mount: mount,
    destroy: destroy,
    update: update,
    style: style$1,
    isWithin: isWithin
  };
  return self;
}

function Slides(Splide2, Components2, options) {
  var _EventInterface2 = _get__("EventInterface")(Splide2),
      on = _EventInterface2.on,
      emit = _EventInterface2.emit,
      bind = _EventInterface2.bind;

  var _Components2$Elements = Components2.Elements,
      slides = _Components2$Elements.slides,
      list = _Components2$Elements.list;
  var Slides2 = [];

  function mount() {
    init();
    on(_get__("EVENT_REFRESH"), destroy);
    on(_get__("EVENT_REFRESH"), init);
  }

  function init() {
    slides.forEach(function (slide, index) {
      register(slide, index, -1);
    });
  }

  function destroy() {
    forEach$1(function (Slide2) {
      Slide2.destroy();
    });

    _get__("empty")(Slides2);
  }

  function update() {
    forEach$1(function (Slide2) {
      Slide2.update();
    });
  }

  function register(slide, index, slideIndex) {
    var object = _get__("Slide$1")(Splide2, index, slideIndex, slide);

    object.mount();
    Slides2.push(object);
    Slides2.sort(function (Slide1, Slide2) {
      return Slide1.index - Slide2.index;
    });
  }

  function get(excludeClones) {
    return excludeClones ? filter(function (Slide2) {
      return !Slide2.isClone;
    }) : Slides2;
  }

  function getIn(page) {
    var Controller = Components2.Controller;
    var index = Controller.toIndex(page);
    var max = Controller.hasFocus() ? 1 : options.perPage;
    return filter(function (Slide2) {
      return _get__("between")(Slide2.index, index, index + max - 1);
    });
  }

  function getAt(index) {
    return filter(index)[0];
  }

  function add(items, index) {
    _get__("forEach")(items, function (slide) {
      if (_get__("isString")(slide)) {
        slide = _get__("parseHtml")(slide);
      }

      if (_get__("isHTMLElement")(slide)) {
        var ref = slides[index];
        ref ? _get__("before")(slide, ref) : _get__("append")(list, slide);

        _get__("addClass")(slide, options.classes.slide);

        observeImages(slide, _get__("apply")(emit, _get__("EVENT_RESIZE")));
      }
    });

    emit(_get__("EVENT_REFRESH"));
  }

  function remove$1(matcher) {
    _get__("remove")(filter(matcher).map(function (Slide2) {
      return Slide2.slide;
    }));

    emit(_get__("EVENT_REFRESH"));
  }

  function forEach$1(iteratee, excludeClones) {
    get(excludeClones).forEach(iteratee);
  }

  function filter(matcher) {
    return Slides2.filter(_get__("isFunction")(matcher) ? matcher : function (Slide2) {
      return _get__("isString")(matcher) ? _get__("matches")(Slide2.slide, matcher) : _get__("includes")(_get__("toArray")(matcher), Slide2.index);
    });
  }

  function style(prop, value, useContainer) {
    forEach$1(function (Slide2) {
      Slide2.style(prop, value, useContainer);
    });
  }

  function observeImages(elm, callback) {
    var images = _get__("queryAll")(elm, "img");

    var length = images.length;

    if (length) {
      images.forEach(function (img) {
        bind(img, "load error", function () {
          if (! --length) {
            callback();
          }
        });
      });
    } else {
      callback();
    }
  }

  function getLength(excludeClones) {
    return excludeClones ? slides.length : Slides2.length;
  }

  function isEnough() {
    return Slides2.length > options.perPage;
  }

  return {
    mount: mount,
    destroy: destroy,
    update: update,
    register: register,
    get: get,
    getIn: getIn,
    getAt: getAt,
    add: add,
    remove: remove$1,
    forEach: forEach$1,
    filter: filter,
    style: style,
    getLength: getLength,
    isEnough: isEnough
  };
}

function Layout(Splide2, Components2, options) {
  var _EventInterface3 = _get__("EventInterface")(Splide2),
      on = _EventInterface3.on,
      bind = _EventInterface3.bind,
      emit = _EventInterface3.emit;

  var Slides = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var _Components2$Elements2 = Components2.Elements,
      root = _Components2$Elements2.root,
      track = _Components2$Elements2.track,
      list = _Components2$Elements2.list;
  var getAt = Slides.getAt,
      styleSlides = Slides.style;
  var vertical;
  var rootRect;
  var overflow;

  function mount() {
    init();
    bind(window, "resize load", _get__("Throttle")(_get__("apply")(emit, _get__("EVENT_RESIZE"))));
    on([_get__("EVENT_UPDATED"), _get__("EVENT_REFRESH")], init);
    on(_get__("EVENT_RESIZE"), resize);
  }

  function init() {
    vertical = options.direction === _get__("TTB");

    _get__("style")(root, "maxWidth", _get__("unit")(options.width));

    _get__("style")(track, resolve("paddingLeft"), cssPadding(false));

    _get__("style")(track, resolve("paddingRight"), cssPadding(true));

    resize(true);
  }

  function resize(force) {
    var newRect = _get__("rect")(root);

    if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
      _get__("style")(track, "height", cssTrackHeight());

      styleSlides(resolve("marginRight"), _get__("unit")(options.gap));
      styleSlides("width", cssSlideWidth());
      styleSlides("height", cssSlideHeight(), true);
      rootRect = newRect;
      emit(_get__("EVENT_RESIZED"));

      if (overflow !== (overflow = isOverflow())) {
        _get__("toggleClass")(root, _get__("CLASS_OVERFLOW"), overflow);

        emit(_get__("EVENT_OVERFLOW"), overflow);
      }
    }
  }

  function cssPadding(right) {
    var padding = options.padding;
    var prop = resolve(right ? "right" : "left");
    return padding && _get__("unit")(padding[prop] || (_get__("isObject")(padding) ? 0 : padding)) || "0px";
  }

  function cssTrackHeight() {
    var height = "";

    if (vertical) {
      height = cssHeight();

      _get__("assert")(height, "height or heightRatio is missing.");

      height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
    }

    return height;
  }

  function cssHeight() {
    return _get__("unit")(options.height || _get__("rect")(list).width * options.heightRatio);
  }

  function cssSlideWidth() {
    return options.autoWidth ? null : _get__("unit")(options.fixedWidth) || (vertical ? "" : cssSlideSize());
  }

  function cssSlideHeight() {
    return _get__("unit")(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
  }

  function cssSlideSize() {
    var gap = _get__("unit")(options.gap);

    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  }

  function listSize() {
    return _get__("rect")(list)[resolve("width")];
  }

  function slideSize(index, withoutGap) {
    var Slide = getAt(index || 0);
    return Slide ? _get__("rect")(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
  }

  function totalSize(index, withoutGap) {
    var Slide = getAt(index);

    if (Slide) {
      var right = _get__("rect")(Slide.slide)[resolve("right")];

      var left = _get__("rect")(list)[resolve("left")];

      return _get__("abs")(right - left) + (withoutGap ? 0 : getGap());
    }

    return 0;
  }

  function sliderSize(withoutGap) {
    return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
  }

  function getGap() {
    var Slide = getAt(0);
    return Slide && parseFloat(_get__("style")(Slide.slide, resolve("marginRight"))) || 0;
  }

  function getPadding(right) {
    return parseFloat(_get__("style")(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
  }

  function isOverflow() {
    return Splide2.is(_get__("FADE")) || sliderSize(true) > listSize();
  }

  return {
    mount: mount,
    resize: resize,
    listSize: listSize,
    slideSize: slideSize,
    sliderSize: sliderSize,
    totalSize: totalSize,
    getPadding: getPadding,
    isOverflow: isOverflow
  };
}

var MULTIPLIER = 2;

function Clones(Splide2, Components2, options) {
  var event = _get__("EventInterface")(Splide2);

  var on = event.on;
  var Elements = Components2.Elements,
      Slides = Components2.Slides;
  var resolve = Components2.Direction.resolve;
  var clones = [];
  var cloneCount;

  function mount() {
    on(_get__("EVENT_REFRESH"), remount);
    on([_get__("EVENT_UPDATED"), _get__("EVENT_RESIZE")], observe);

    if (cloneCount = computeCloneCount()) {
      generate(cloneCount);
      Components2.Layout.resize(true);
    }
  }

  function remount() {
    destroy();
    mount();
  }

  function destroy() {
    _get__("remove")(clones);

    _get__("empty")(clones);

    event.destroy();
  }

  function observe() {
    var count = computeCloneCount();

    if (cloneCount !== count) {
      if (cloneCount < count || !count) {
        event.emit(_get__("EVENT_REFRESH"));
      }
    }
  }

  function generate(count) {
    var slides = Slides.get().slice();
    var length = slides.length;

    if (length) {
      while (slides.length < count) {
        _get__("push")(slides, slides);
      }

      _get__("push")(slides.slice(-count), slides.slice(0, count)).forEach(function (Slide, index) {
        var isHead = index < count;
        var clone = cloneDeep(Slide.slide, index);
        isHead ? _get__("before")(clone, slides[0].slide) : _get__("append")(Elements.list, clone);

        _get__("push")(clones, clone);

        Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
      });
    }
  }

  function cloneDeep(elm, index) {
    var clone = elm.cloneNode(true);

    _get__("addClass")(clone, options.classes.clone);

    clone.id = Splide2.root.id + "-clone" + _get__("pad")(index + 1);
    return clone;
  }

  function computeCloneCount() {
    var clones2 = options.clones;

    if (!Splide2.is(_get__("LOOP"))) {
      clones2 = 0;
    } else if (_get__("isUndefined")(clones2)) {
      var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);

      var fixedCount = fixedSize && _get__("ceil")(_get__("rect")(Elements.track)[resolve("width")] / fixedSize);

      clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * _get__("MULTIPLIER");
    }

    return clones2;
  }

  return {
    mount: mount,
    destroy: destroy
  };
}

function Move(Splide2, Components2, options) {
  var _EventInterface4 = _get__("EventInterface")(Splide2),
      on = _EventInterface4.on,
      emit = _EventInterface4.emit;

  var set = Splide2.state.set;
  var _Components2$Layout = Components2.Layout,
      slideSize = _Components2$Layout.slideSize,
      getPadding = _Components2$Layout.getPadding,
      totalSize = _Components2$Layout.totalSize,
      listSize = _Components2$Layout.listSize,
      sliderSize = _Components2$Layout.sliderSize;
  var _Components2$Directio = Components2.Direction,
      resolve = _Components2$Directio.resolve,
      orient = _Components2$Directio.orient;
  var _Components2$Elements3 = Components2.Elements,
      list = _Components2$Elements3.list,
      track = _Components2$Elements3.track;
  var Transition;

  function mount() {
    Transition = Components2.Transition;
    on([_get__("EVENT_MOUNTED"), _get__("EVENT_RESIZED"), _get__("EVENT_UPDATED"), _get__("EVENT_REFRESH")], reposition);
  }

  function reposition() {
    if (!Components2.Controller.isBusy()) {
      Components2.Scroll.cancel();
      jump(Splide2.index);
      Components2.Slides.update();
    }
  }

  function move(dest, index, prev, callback) {
    if (dest !== index && canShift(dest > prev)) {
      cancel();
      translate(shift(getPosition(), dest > prev), true);
    }

    set(_get__("MOVING"));
    emit(_get__("EVENT_MOVE"), index, prev, dest);
    Transition.start(index, function () {
      set(_get__("IDLE"));
      emit(_get__("EVENT_MOVED"), index, prev, dest);
      callback && callback();
    });
  }

  function jump(index) {
    translate(toPosition(index, true));
  }

  function translate(position, preventLoop) {
    if (!Splide2.is(_get__("FADE"))) {
      var destination = preventLoop ? position : loop(position);

      _get__("style")(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");

      position !== destination && emit(_get__("EVENT_SHIFTED"));
    }
  }

  function loop(position) {
    if (Splide2.is(_get__("LOOP"))) {
      var index = toIndex(position);
      var exceededMax = index > Components2.Controller.getEnd();
      var exceededMin = index < 0;

      if (exceededMin || exceededMax) {
        position = shift(position, exceededMax);
      }
    }

    return position;
  }

  function shift(position, backwards) {
    var excess = position - getLimit(backwards);
    var size = sliderSize();
    position -= orient(size * (_get__("ceil")(_get__("abs")(excess) / size) || 1)) * (backwards ? 1 : -1);
    return position;
  }

  function cancel() {
    translate(getPosition(), true);
    Transition.cancel();
  }

  function toIndex(position) {
    var Slides = Components2.Slides.get();
    var index = 0;
    var minDistance = Infinity;

    for (var i = 0; i < Slides.length; i++) {
      var slideIndex = Slides[i].index;

      var distance = _get__("abs")(toPosition(slideIndex, true) - position);

      if (distance <= minDistance) {
        minDistance = distance;
        index = slideIndex;
      } else {
        break;
      }
    }

    return index;
  }

  function toPosition(index, trimming) {
    var position = orient(totalSize(index - 1) - offset(index));
    return trimming ? trim(position) : position;
  }

  function getPosition() {
    var left = resolve("left");
    return _get__("rect")(list)[left] - _get__("rect")(track)[left] + orient(getPadding(false));
  }

  function trim(position) {
    if (options.trimSpace && Splide2.is(_get__("SLIDE"))) {
      position = _get__("clamp")(position, 0, orient(sliderSize(true) - listSize()));
    }

    return position;
  }

  function offset(index) {
    var focus = options.focus;
    return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
  }

  function getLimit(max) {
    return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
  }

  function canShift(backwards) {
    var shifted = orient(shift(getPosition(), backwards));
    return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - _get__("rect")(track)[resolve("width")];
  }

  function exceededLimit(max, position) {
    position = _get__("isUndefined")(position) ? getPosition() : position;
    var exceededMin = max !== true && orient(position) < orient(getLimit(false));
    var exceededMax = max !== false && orient(position) > orient(getLimit(true));
    return exceededMin || exceededMax;
  }

  return {
    mount: mount,
    move: move,
    jump: jump,
    translate: translate,
    shift: shift,
    cancel: cancel,
    toIndex: toIndex,
    toPosition: toPosition,
    getPosition: getPosition,
    getLimit: getLimit,
    exceededLimit: exceededLimit,
    reposition: reposition
  };
}

function Controller(Splide2, Components2, options) {
  var _EventInterface5 = _get__("EventInterface")(Splide2),
      on = _EventInterface5.on,
      emit = _EventInterface5.emit;

  var Move = Components2.Move;
  var getPosition = Move.getPosition,
      getLimit = Move.getLimit,
      toPosition = Move.toPosition;
  var _Components2$Slides = Components2.Slides,
      isEnough = _Components2$Slides.isEnough,
      getLength = _Components2$Slides.getLength;
  var omitEnd = options.omitEnd;
  var isLoop = Splide2.is(_get__("LOOP"));
  var isSlide = Splide2.is(_get__("SLIDE"));

  var getNext = _get__("apply")(getAdjacent, false);

  var getPrev = _get__("apply")(getAdjacent, true);

  var currIndex = options.start || 0;
  var endIndex;
  var prevIndex = currIndex;
  var slideCount;
  var perMove;
  var perPage;

  function mount() {
    init();
    on([_get__("EVENT_UPDATED"), _get__("EVENT_REFRESH"), _get__("EVENT_END_INDEX_CHANGED")], init);
    on(_get__("EVENT_RESIZED"), onResized);
  }

  function init() {
    slideCount = getLength(true);
    perMove = options.perMove;
    perPage = options.perPage;
    endIndex = getEnd();

    var index = _get__("clamp")(currIndex, 0, omitEnd ? endIndex : slideCount - 1);

    if (index !== currIndex) {
      currIndex = index;
      Move.reposition();
    }
  }

  function onResized() {
    if (endIndex !== getEnd()) {
      emit(_get__("EVENT_END_INDEX_CHANGED"));
    }
  }

  function go(control, allowSameIndex, callback) {
    if (!isBusy()) {
      var dest = parse(control);
      var index = loop(dest);

      if (index > -1 && (allowSameIndex || index !== currIndex)) {
        setIndex(index);
        Move.move(dest, index, prevIndex, callback);
      }
    }
  }

  function scroll(destination, duration, snap, callback) {
    Components2.Scroll.scroll(destination, duration, snap, function () {
      var index = loop(Move.toIndex(getPosition()));
      setIndex(omitEnd ? _get__("min")(index, endIndex) : index);
      callback && callback();
    });
  }

  function parse(control) {
    var index = currIndex;

    if (_get__("isString")(control)) {
      var _ref = control.match(/([+\-<>])(\d+)?/) || [],
          indicator = _ref[1],
          number = _ref[2];

      if (indicator === "+" || indicator === "-") {
        index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
      } else if (indicator === ">") {
        index = number ? toIndex(+number) : getNext(true);
      } else if (indicator === "<") {
        index = getPrev(true);
      }
    } else {
      index = isLoop ? control : _get__("clamp")(control, 0, endIndex);
    }

    return index;
  }

  function getAdjacent(prev, destination) {
    var number = perMove || (hasFocus() ? 1 : perPage);
    var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));

    if (dest === -1 && isSlide) {
      if (!_get__("approximatelyEqual")(getPosition(), getLimit(!prev), 1)) {
        return prev ? 0 : endIndex;
      }
    }

    return destination ? dest : loop(dest);
  }

  function computeDestIndex(dest, from, snapPage) {
    if (isEnough() || hasFocus()) {
      var index = computeMovableDestIndex(dest);

      if (index !== dest) {
        from = dest;
        dest = index;
        snapPage = false;
      }

      if (dest < 0 || dest > endIndex) {
        if (!perMove && (_get__("between")(0, dest, from, true) || _get__("between")(endIndex, from, dest, true))) {
          dest = toIndex(toPage(dest));
        } else {
          if (isLoop) {
            dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
          } else if (options.rewind) {
            dest = dest < 0 ? endIndex : 0;
          } else {
            dest = -1;
          }
        }
      } else {
        if (snapPage && dest !== from) {
          dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        }
      }
    } else {
      dest = -1;
    }

    return dest;
  }

  function computeMovableDestIndex(dest) {
    if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
      var position = getPosition();

      while (position === toPosition(dest, true) && _get__("between")(dest, 0, Splide2.length - 1, !options.rewind)) {
        dest < currIndex ? --dest : ++dest;
      }
    }

    return dest;
  }

  function loop(index) {
    return isLoop ? (index + slideCount) % slideCount || 0 : index;
  }

  function getEnd() {
    var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);

    while (omitEnd && end-- > 0) {
      if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
        end++;
        break;
      }
    }

    return _get__("clamp")(end, 0, slideCount - 1);
  }

  function toIndex(page) {
    return _get__("clamp")(hasFocus() ? page : perPage * page, 0, endIndex);
  }

  function toPage(index) {
    return hasFocus() ? _get__("min")(index, endIndex) : _get__("floor")((index >= endIndex ? slideCount - 1 : index) / perPage);
  }

  function toDest(destination) {
    var closest = Move.toIndex(destination);
    return isSlide ? _get__("clamp")(closest, 0, endIndex) : closest;
  }

  function setIndex(index) {
    if (index !== currIndex) {
      prevIndex = currIndex;
      currIndex = index;
    }
  }

  function getIndex(prev) {
    return prev ? prevIndex : currIndex;
  }

  function hasFocus() {
    return !_get__("isUndefined")(options.focus) || options.isNavigation;
  }

  function isBusy() {
    return Splide2.state.is([_get__("MOVING"), _get__("SCROLLING")]) && !!options.waitForTransition;
  }

  return {
    mount: mount,
    go: go,
    scroll: scroll,
    getNext: getNext,
    getPrev: getPrev,
    getAdjacent: getAdjacent,
    getEnd: getEnd,
    setIndex: setIndex,
    getIndex: getIndex,
    toIndex: toIndex,
    toPage: toPage,
    toDest: toDest,
    hasFocus: hasFocus,
    isBusy: isBusy
  };
}

var XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var SIZE = 40;

function Arrows(Splide2, Components2, options) {
  var event = _get__("EventInterface")(Splide2);

  var on = event.on,
      bind = event.bind,
      emit = event.emit;
  var classes = options.classes,
      i18n = options.i18n;
  var Elements = Components2.Elements,
      Controller = Components2.Controller;
  var placeholder = Elements.arrows,
      track = Elements.track;
  var wrapper = placeholder;
  var prev = Elements.prev;
  var next = Elements.next;
  var created;
  var wrapperClasses;
  var arrows = {};

  function mount() {
    init();
    on(_get__("EVENT_UPDATED"), remount);
  }

  function remount() {
    destroy();
    mount();
  }

  function init() {
    var enabled = options.arrows;

    if (enabled && !(prev && next)) {
      createArrows();
    }

    if (prev && next) {
      _get__("assign")(arrows, {
        prev: prev,
        next: next
      });

      _get__("display")(wrapper, enabled ? "" : "none");

      _get__("addClass")(wrapper, wrapperClasses = _get__("CLASS_ARROWS") + "--" + options.direction);

      if (enabled) {
        listen();
        update();

        _get__("setAttribute")([prev, next], _get__("ARIA_CONTROLS"), track.id);

        emit(_get__("EVENT_ARROWS_MOUNTED"), prev, next);
      }
    }
  }

  function destroy() {
    event.destroy();

    _get__("removeClass")(wrapper, wrapperClasses);

    if (created) {
      _get__("remove")(placeholder ? [prev, next] : wrapper);

      prev = next = null;
    } else {
      _get__("removeAttribute")([prev, next], _get__("ALL_ATTRIBUTES"));
    }
  }

  function listen() {
    on([_get__("EVENT_MOUNTED"), _get__("EVENT_MOVED"), _get__("EVENT_REFRESH"), _get__("EVENT_SCROLLED"), _get__("EVENT_END_INDEX_CHANGED")], update);
    bind(next, "click", _get__("apply")(go, ">"));
    bind(prev, "click", _get__("apply")(go, "<"));
  }

  function go(control) {
    Controller.go(control, true);
  }

  function createArrows() {
    wrapper = placeholder || _get__("create")("div", classes.arrows);
    prev = createArrow(true);
    next = createArrow(false);
    created = true;

    _get__("append")(wrapper, [prev, next]);

    !placeholder && _get__("before")(wrapper, track);
  }

  function createArrow(prev2) {
    var arrow = "<button class=\"" + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + "\" type=\"button\"><svg xmlns=\"" + _get__("XML_NAME_SPACE") + "\" viewBox=\"0 0 " + _get__("SIZE") + " " + _get__("SIZE") + "\" width=\"" + _get__("SIZE") + "\" height=\"" + _get__("SIZE") + "\" focusable=\"false\"><path d=\"" + (options.arrowPath || _get__("PATH")) + "\" />";
    return _get__("parseHtml")(arrow);
  }

  function update() {
    if (prev && next) {
      var index = Splide2.index;
      var prevIndex = Controller.getPrev();
      var nextIndex = Controller.getNext();
      var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
      var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
      prev.disabled = prevIndex < 0;
      next.disabled = nextIndex < 0;

      _get__("setAttribute")(prev, _get__("ARIA_LABEL"), prevLabel);

      _get__("setAttribute")(next, _get__("ARIA_LABEL"), nextLabel);

      emit(_get__("EVENT_ARROWS_UPDATED"), prev, next, prevIndex, nextIndex);
    }
  }

  return {
    arrows: arrows,
    mount: mount,
    destroy: destroy,
    update: update
  };
}

var INTERVAL_DATA_ATTRIBUTE = _get__("DATA_ATTRIBUTE") + "-interval";

function Autoplay(Splide2, Components2, options) {
  var _EventInterface6 = _get__("EventInterface")(Splide2),
      on = _EventInterface6.on,
      bind = _EventInterface6.bind,
      emit = _EventInterface6.emit;

  var interval = _get__("RequestInterval")(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);

  var isPaused = interval.isPaused;
  var Elements = Components2.Elements,
      _Components2$Elements4 = Components2.Elements,
      root = _Components2$Elements4.root,
      toggle = _Components2$Elements4.toggle;
  var autoplay = options.autoplay;
  var hovered;
  var focused;
  var stopped = autoplay === "pause";

  function mount() {
    if (autoplay) {
      listen();
      toggle && _get__("setAttribute")(toggle, _get__("ARIA_CONTROLS"), Elements.track.id);
      stopped || play();
      update();
    }
  }

  function listen() {
    if (options.pauseOnHover) {
      bind(root, "mouseenter mouseleave", function (e) {
        hovered = e.type === "mouseenter";
        autoToggle();
      });
    }

    if (options.pauseOnFocus) {
      bind(root, "focusin focusout", function (e) {
        focused = e.type === "focusin";
        autoToggle();
      });
    }

    if (toggle) {
      bind(toggle, "click", function () {
        stopped ? play() : pause(true);
      });
    }

    on([_get__("EVENT_MOVE"), _get__("EVENT_SCROLL"), _get__("EVENT_REFRESH")], interval.rewind);
    on(_get__("EVENT_MOVE"), onMove);
  }

  function play() {
    if (isPaused() && Components2.Slides.isEnough()) {
      interval.start(!options.resetProgress);
      focused = hovered = stopped = false;
      update();
      emit(_get__("EVENT_AUTOPLAY_PLAY"));
    }
  }

  function pause(stop) {
    if (stop === void 0) {
      stop = true;
    }

    stopped = !!stop;
    update();

    if (!isPaused()) {
      interval.pause();
      emit(_get__("EVENT_AUTOPLAY_PAUSE"));
    }
  }

  function autoToggle() {
    if (!stopped) {
      hovered || focused ? pause(false) : play();
    }
  }

  function update() {
    if (toggle) {
      _get__("toggleClass")(toggle, _get__("CLASS_ACTIVE"), !stopped);

      _get__("setAttribute")(toggle, _get__("ARIA_LABEL"), options.i18n[stopped ? "play" : "pause"]);
    }
  }

  function onAnimationFrame(rate) {
    var bar = Elements.bar;
    bar && _get__("style")(bar, "width", rate * 100 + "%");
    emit(_get__("EVENT_AUTOPLAY_PLAYING"), rate);
  }

  function onMove(index) {
    var Slide = Components2.Slides.getAt(index);
    interval.set(Slide && +_get__("getAttribute")(Slide.slide, _get__("INTERVAL_DATA_ATTRIBUTE")) || options.interval);
  }

  return {
    mount: mount,
    destroy: interval.cancel,
    play: play,
    pause: pause,
    isPaused: isPaused
  };
}

function Cover(Splide2, Components2, options) {
  var _EventInterface7 = _get__("EventInterface")(Splide2),
      on = _EventInterface7.on;

  function mount() {
    if (options.cover) {
      on(_get__("EVENT_LAZYLOAD_LOADED"), _get__("apply")(toggle, true));
      on([_get__("EVENT_MOUNTED"), _get__("EVENT_UPDATED"), _get__("EVENT_REFRESH")], _get__("apply")(cover, true));
    }
  }

  function cover(cover2) {
    Components2.Slides.forEach(function (Slide) {
      var img = _get__("child")(Slide.container || Slide.slide, "img");

      if (img && img.src) {
        toggle(cover2, img, Slide);
      }
    });
  }

  function toggle(cover2, img, Slide) {
    Slide.style("background", cover2 ? "center/cover no-repeat url(\"" + img.src + "\")" : "", true);

    _get__("display")(img, cover2 ? "none" : "");
  }

  return {
    mount: mount,
    destroy: _get__("apply")(cover, false)
  };
}

var BOUNCE_DIFF_THRESHOLD = 10;
var BOUNCE_DURATION = 600;
var FRICTION_FACTOR = 0.6;
var BASE_VELOCITY = 1.5;
var MIN_DURATION = 800;

function Scroll(Splide2, Components2, options) {
  var _EventInterface8 = _get__("EventInterface")(Splide2),
      on = _EventInterface8.on,
      emit = _EventInterface8.emit;

  var set = Splide2.state.set;
  var Move = Components2.Move;
  var getPosition = Move.getPosition,
      getLimit = Move.getLimit,
      exceededLimit = Move.exceededLimit,
      translate = Move.translate;
  var isSlide = Splide2.is(_get__("SLIDE"));
  var interval;
  var callback;
  var friction = 1;

  function mount() {
    on(_get__("EVENT_MOVE"), clear);
    on([_get__("EVENT_UPDATED"), _get__("EVENT_REFRESH")], cancel);
  }

  function scroll(destination, duration, snap, onScrolled, noConstrain) {
    var from = getPosition();
    clear();

    if (snap && (!isSlide || !exceededLimit())) {
      var size = Components2.Layout.sliderSize();
      var offset = _get__("sign")(destination) * size * _get__("floor")(_get__("abs")(destination) / size) || 0;
      destination = Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
    }

    var noDistance = _get__("approximatelyEqual")(from, destination, 1);

    friction = 1;
    duration = noDistance ? 0 : duration || _get__("max")(_get__("abs")(destination - from) / _get__("BASE_VELOCITY"), _get__("MIN_DURATION"));
    callback = onScrolled;
    interval = _get__("RequestInterval")(duration, onEnd, _get__("apply")(update, from, destination, noConstrain), 1);
    set(_get__("SCROLLING"));
    emit(_get__("EVENT_SCROLL"));
    interval.start();
  }

  function onEnd() {
    set(_get__("IDLE"));
    callback && callback();
    emit(_get__("EVENT_SCROLLED"));
  }

  function update(from, to, noConstrain, rate) {
    var position = getPosition();
    var target = from + (to - from) * easing(rate);
    var diff = (target - position) * friction;
    translate(position + diff);

    if (isSlide && !noConstrain && exceededLimit()) {
      friction *= _get__("FRICTION_FACTOR");

      if (_get__("abs")(diff) < _get__("BOUNCE_DIFF_THRESHOLD")) {
        scroll(getLimit(exceededLimit(true)), _get__("BOUNCE_DURATION"), false, callback, true);
      }
    }
  }

  function clear() {
    if (interval) {
      interval.cancel();
    }
  }

  function cancel() {
    if (interval && !interval.isPaused()) {
      clear();
      onEnd();
    }
  }

  function easing(t) {
    var easingFunc = options.easingFunc;
    return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
  }

  return {
    mount: mount,
    destroy: clear,
    scroll: scroll,
    cancel: cancel
  };
}

var SCROLL_LISTENER_OPTIONS = {
  passive: false,
  capture: true
};

function Drag(Splide2, Components2, options) {
  var _EventInterface9 = _get__("EventInterface")(Splide2),
      on = _EventInterface9.on,
      emit = _EventInterface9.emit,
      bind = _EventInterface9.bind,
      unbind = _EventInterface9.unbind;

  var state = Splide2.state;
  var Move = Components2.Move,
      Scroll = Components2.Scroll,
      Controller = Components2.Controller,
      track = Components2.Elements.track,
      reduce = Components2.Media.reduce;
  var _Components2$Directio2 = Components2.Direction,
      resolve = _Components2$Directio2.resolve,
      orient = _Components2$Directio2.orient;
  var getPosition = Move.getPosition,
      exceededLimit = Move.exceededLimit;
  var basePosition;
  var baseEvent;
  var prevBaseEvent;
  var isFree;
  var dragging;
  var exceeded = false;
  var clickPrevented;
  var disabled;
  var target;

  function mount() {
    bind(track, _get__("POINTER_MOVE_EVENTS"), _get__("noop"), _get__("SCROLL_LISTENER_OPTIONS"));
    bind(track, _get__("POINTER_UP_EVENTS"), _get__("noop"), _get__("SCROLL_LISTENER_OPTIONS"));
    bind(track, _get__("POINTER_DOWN_EVENTS"), onPointerDown, _get__("SCROLL_LISTENER_OPTIONS"));
    bind(track, "click", onClick, {
      capture: true
    });
    bind(track, "dragstart", _get__("prevent"));
    on([_get__("EVENT_MOUNTED"), _get__("EVENT_UPDATED")], init);
  }

  function init() {
    var drag = options.drag;
    disable(!drag);
    isFree = drag === "free";
  }

  function onPointerDown(e) {
    clickPrevented = false;

    if (!disabled) {
      var isTouch = isTouchEvent(e);

      if (isDraggable(e.target) && (isTouch || !e.button)) {
        if (!Controller.isBusy()) {
          target = isTouch ? track : window;
          dragging = state.is([_get__("MOVING"), _get__("SCROLLING")]);
          prevBaseEvent = null;
          bind(target, _get__("POINTER_MOVE_EVENTS"), onPointerMove, _get__("SCROLL_LISTENER_OPTIONS"));
          bind(target, _get__("POINTER_UP_EVENTS"), onPointerUp, _get__("SCROLL_LISTENER_OPTIONS"));
          Move.cancel();
          Scroll.cancel();
          save(e);
        } else {
          _get__("prevent")(e, true);
        }
      }
    }
  }

  function onPointerMove(e) {
    if (!state.is(_get__("DRAGGING"))) {
      state.set(_get__("DRAGGING"));
      emit(_get__("EVENT_DRAG"));
    }

    if (e.cancelable) {
      if (dragging) {
        Move.translate(basePosition + constrain(diffCoord(e)));

        var expired = diffTime(e) > _get__("LOG_INTERVAL");

        var hasExceeded = exceeded !== (exceeded = exceededLimit());

        if (expired || hasExceeded) {
          save(e);
        }

        clickPrevented = true;
        emit(_get__("EVENT_DRAGGING"));

        _get__("prevent")(e);
      } else if (isSliderDirection(e)) {
        dragging = shouldStart(e);

        _get__("prevent")(e);
      }
    }
  }

  function onPointerUp(e) {
    if (state.is(_get__("DRAGGING"))) {
      state.set(_get__("IDLE"));
      emit(_get__("EVENT_DRAGGED"));
    }

    if (dragging) {
      move(e);

      _get__("prevent")(e);
    }

    unbind(target, _get__("POINTER_MOVE_EVENTS"), onPointerMove);
    unbind(target, _get__("POINTER_UP_EVENTS"), onPointerUp);
    dragging = false;
  }

  function onClick(e) {
    if (!disabled && clickPrevented) {
      _get__("prevent")(e, true);
    }
  }

  function save(e) {
    prevBaseEvent = baseEvent;
    baseEvent = e;
    basePosition = getPosition();
  }

  function move(e) {
    var velocity = computeVelocity(e);
    var destination = computeDestination(velocity);
    var rewind = options.rewind && options.rewindByDrag;
    reduce(false);

    if (isFree) {
      Controller.scroll(destination, 0, options.snap);
    } else if (Splide2.is(_get__("FADE"))) {
      Controller.go(orient(_get__("sign")(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
    } else if (Splide2.is(_get__("SLIDE")) && exceeded && rewind) {
      Controller.go(exceededLimit(true) ? ">" : "<");
    } else {
      Controller.go(Controller.toDest(destination), true);
    }

    reduce(true);
  }

  function shouldStart(e) {
    var thresholds = options.dragMinThreshold;

    var isObj = _get__("isObject")(thresholds);

    var mouse = isObj && thresholds.mouse || 0;
    var touch = (isObj ? thresholds.touch : +thresholds) || 10;
    return _get__("abs")(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
  }

  function isSliderDirection(e) {
    return _get__("abs")(diffCoord(e)) > _get__("abs")(diffCoord(e, true));
  }

  function computeVelocity(e) {
    if (Splide2.is(_get__("LOOP")) || !exceeded) {
      var time = diffTime(e);

      if (time && time < _get__("LOG_INTERVAL")) {
        return diffCoord(e) / time;
      }
    }

    return 0;
  }

  function computeDestination(velocity) {
    return getPosition() + _get__("sign")(velocity) * _get__("min")(_get__("abs")(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
  }

  function diffCoord(e, orthogonal) {
    return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
  }

  function diffTime(e) {
    return _get__("timeOf")(e) - _get__("timeOf")(getBaseEvent(e));
  }

  function getBaseEvent(e) {
    return baseEvent === e && prevBaseEvent || baseEvent;
  }

  function coordOf(e, orthogonal) {
    return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
  }

  function constrain(diff) {
    return diff / (exceeded && Splide2.is(_get__("SLIDE")) ? _get__("FRICTION") : 1);
  }

  function isDraggable(target2) {
    var noDrag = options.noDrag;
    return !_get__("matches")(target2, "." + _get__("CLASS_PAGINATION_PAGE") + ", ." + _get__("CLASS_ARROW")) && (!noDrag || !_get__("matches")(target2, noDrag));
  }

  function isTouchEvent(e) {
    return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
  }

  function isDragging() {
    return dragging;
  }

  function disable(value) {
    disabled = value;
  }

  return {
    mount: mount,
    disable: disable,
    isDragging: isDragging
  };
}

var NORMALIZATION_MAP = {
  Spacebar: " ",
  Right: _get__("ARROW_RIGHT"),
  Left: _get__("ARROW_LEFT"),
  Up: _get__("ARROW_UP"),
  Down: _get__("ARROW_DOWN")
};

function normalizeKey(key) {
  key = _get__("isString")(key) ? key : key.key;
  return _get__("NORMALIZATION_MAP")[key] || key;
}

var KEYBOARD_EVENT = "keydown";

function Keyboard(Splide2, Components2, options) {
  var _EventInterface10 = _get__("EventInterface")(Splide2),
      on = _EventInterface10.on,
      bind = _EventInterface10.bind,
      unbind = _EventInterface10.unbind;

  var root = Splide2.root;
  var resolve = Components2.Direction.resolve;
  var target;
  var disabled;

  function mount() {
    init();
    on(_get__("EVENT_UPDATED"), destroy);
    on(_get__("EVENT_UPDATED"), init);
    on(_get__("EVENT_MOVE"), onMove);
  }

  function init() {
    var keyboard = options.keyboard;

    if (keyboard) {
      target = keyboard === "global" ? window : root;
      bind(target, _get__("KEYBOARD_EVENT"), onKeydown);
    }
  }

  function destroy() {
    unbind(target, _get__("KEYBOARD_EVENT"));
  }

  function disable(value) {
    disabled = value;
  }

  function onMove() {
    var _disabled = disabled;
    disabled = true;

    _get__("nextTick")(function () {
      disabled = _disabled;
    });
  }

  function onKeydown(e) {
    if (!disabled) {
      var key = _get__("normalizeKey")(e);

      if (key === resolve(_get__("ARROW_LEFT"))) {
        Splide2.go("<");
      } else if (key === resolve(_get__("ARROW_RIGHT"))) {
        Splide2.go(">");
      }
    }
  }

  return {
    mount: mount,
    destroy: destroy,
    disable: disable
  };
}

var SRC_DATA_ATTRIBUTE = _get__("DATA_ATTRIBUTE") + "-lazy";
var SRCSET_DATA_ATTRIBUTE = _get__("SRC_DATA_ATTRIBUTE") + "-srcset";
var IMAGE_SELECTOR = "[" + _get__("SRC_DATA_ATTRIBUTE") + "], [" + _get__("SRCSET_DATA_ATTRIBUTE") + "]";

function LazyLoad(Splide2, Components2, options) {
  var _EventInterface11 = _get__("EventInterface")(Splide2),
      on = _EventInterface11.on,
      off = _EventInterface11.off,
      bind = _EventInterface11.bind,
      emit = _EventInterface11.emit;

  var isSequential = options.lazyLoad === "sequential";
  var events = [_get__("EVENT_MOVED"), _get__("EVENT_SCROLLED")];
  var entries = [];

  function mount() {
    if (options.lazyLoad) {
      init();
      on(_get__("EVENT_REFRESH"), init);
    }
  }

  function init() {
    _get__("empty")(entries);

    register();

    if (isSequential) {
      loadNext();
    } else {
      off(events);
      on(events, check);
      check();
    }
  }

  function register() {
    Components2.Slides.forEach(function (Slide) {
      _get__("queryAll")(Slide.slide, _get__("IMAGE_SELECTOR")).forEach(function (img) {
        var src = _get__("getAttribute")(img, _get__("SRC_DATA_ATTRIBUTE"));

        var srcset = _get__("getAttribute")(img, _get__("SRCSET_DATA_ATTRIBUTE"));

        if (src !== img.src || srcset !== img.srcset) {
          var className = options.classes.spinner;
          var parent = img.parentElement;

          var spinner = _get__("child")(parent, "." + className) || _get__("create")("span", className, parent);

          entries.push([img, Slide, spinner]);
          img.src || _get__("display")(img, "none");
        }
      });
    });
  }

  function check() {
    entries = entries.filter(function (data) {
      var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
      return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
    });
    entries.length || off(events);
  }

  function load(data) {
    var img = data[0];

    _get__("addClass")(data[1].slide, _get__("CLASS_LOADING"));

    bind(img, "load error", _get__("apply")(onLoad, data));

    _get__("setAttribute")(img, "src", _get__("getAttribute")(img, _get__("SRC_DATA_ATTRIBUTE")));

    _get__("setAttribute")(img, "srcset", _get__("getAttribute")(img, _get__("SRCSET_DATA_ATTRIBUTE")));

    _get__("removeAttribute")(img, _get__("SRC_DATA_ATTRIBUTE"));

    _get__("removeAttribute")(img, _get__("SRCSET_DATA_ATTRIBUTE"));
  }

  function onLoad(data, e) {
    var img = data[0],
        Slide = data[1];

    _get__("removeClass")(Slide.slide, _get__("CLASS_LOADING"));

    if (e.type !== "error") {
      _get__("remove")(data[2]);

      _get__("display")(img, "");

      emit(_get__("EVENT_LAZYLOAD_LOADED"), img, Slide);
      emit(_get__("EVENT_RESIZE"));
    }

    isSequential && loadNext();
  }

  function loadNext() {
    entries.length && load(entries.shift());
  }

  return {
    mount: mount,
    destroy: _get__("apply")(_get__("empty"), entries),
    check: check
  };
}

function Pagination(Splide2, Components2, options) {
  var event = _get__("EventInterface")(Splide2);

  var on = event.on,
      emit = event.emit,
      bind = event.bind;
  var Slides = Components2.Slides,
      Elements = Components2.Elements,
      Controller = Components2.Controller;
  var hasFocus = Controller.hasFocus,
      getIndex = Controller.getIndex,
      go = Controller.go;
  var resolve = Components2.Direction.resolve;
  var placeholder = Elements.pagination;
  var items = [];
  var list;
  var paginationClasses;

  function mount() {
    destroy();
    on([_get__("EVENT_UPDATED"), _get__("EVENT_REFRESH"), _get__("EVENT_END_INDEX_CHANGED")], mount);
    var enabled = options.pagination;
    placeholder && _get__("display")(placeholder, enabled ? "" : "none");

    if (enabled) {
      on([_get__("EVENT_MOVE"), _get__("EVENT_SCROLL"), _get__("EVENT_SCROLLED")], update);
      createPagination();
      update();
      emit(_get__("EVENT_PAGINATION_MOUNTED"), {
        list: list,
        items: items
      }, getAt(Splide2.index));
    }
  }

  function destroy() {
    if (list) {
      _get__("remove")(placeholder ? _get__("slice")(list.children) : list);

      _get__("removeClass")(list, paginationClasses);

      _get__("empty")(items);

      list = null;
    }

    event.destroy();
  }

  function createPagination() {
    var length = Splide2.length;
    var classes = options.classes,
        i18n = options.i18n,
        perPage = options.perPage;
    var max = hasFocus() ? Controller.getEnd() + 1 : _get__("ceil")(length / perPage);
    list = placeholder || _get__("create")("ul", classes.pagination, Elements.track.parentElement);

    _get__("addClass")(list, paginationClasses = _get__("CLASS_PAGINATION") + "--" + getDirection());

    _get__("setAttribute")(list, _get__("ROLE"), "tablist");

    _get__("setAttribute")(list, _get__("ARIA_LABEL"), i18n.select);

    _get__("setAttribute")(list, _get__("ARIA_ORIENTATION"), getDirection() === _get__("TTB") ? "vertical" : "");

    for (var i = 0; i < max; i++) {
      var li = _get__("create")("li", null, list);

      var button = _get__("create")("button", {
        "class": classes.page,
        type: "button"
      }, li);

      var controls = Slides.getIn(i).map(function (Slide) {
        return Slide.slide.id;
      });
      var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
      bind(button, "click", _get__("apply")(onClick, i));

      if (options.paginationKeyboard) {
        bind(button, "keydown", _get__("apply")(onKeydown, i));
      }

      _get__("setAttribute")(li, _get__("ROLE"), "presentation");

      _get__("setAttribute")(button, _get__("ROLE"), "tab");

      _get__("setAttribute")(button, _get__("ARIA_CONTROLS"), controls.join(" "));

      _get__("setAttribute")(button, _get__("ARIA_LABEL"), _get__("format")(text, i + 1));

      _get__("setAttribute")(button, _get__("TAB_INDEX"), -1);

      items.push({
        li: li,
        button: button,
        page: i
      });
    }
  }

  function onClick(page) {
    go(">" + page, true);
  }

  function onKeydown(page, e) {
    var length = items.length;

    var key = _get__("normalizeKey")(e);

    var dir = getDirection();
    var nextPage = -1;

    if (key === resolve(_get__("ARROW_RIGHT"), false, dir)) {
      nextPage = ++page % length;
    } else if (key === resolve(_get__("ARROW_LEFT"), false, dir)) {
      nextPage = (--page + length) % length;
    } else if (key === "Home") {
      nextPage = 0;
    } else if (key === "End") {
      nextPage = length - 1;
    }

    var item = items[nextPage];

    if (item) {
      _get__("focus")(item.button);

      go(">" + nextPage);

      _get__("prevent")(e, true);
    }
  }

  function getDirection() {
    return options.paginationDirection || options.direction;
  }

  function getAt(index) {
    return items[Controller.toPage(index)];
  }

  function update() {
    var prev = getAt(getIndex(true));
    var curr = getAt(getIndex());

    if (prev) {
      var button = prev.button;

      _get__("removeClass")(button, _get__("CLASS_ACTIVE"));

      _get__("removeAttribute")(button, _get__("ARIA_SELECTED"));

      _get__("setAttribute")(button, _get__("TAB_INDEX"), -1);
    }

    if (curr) {
      var _button = curr.button;

      _get__("addClass")(_button, _get__("CLASS_ACTIVE"));

      _get__("setAttribute")(_button, _get__("ARIA_SELECTED"), true);

      _get__("setAttribute")(_button, _get__("TAB_INDEX"), "");
    }

    emit(_get__("EVENT_PAGINATION_UPDATED"), {
      list: list,
      items: items
    }, prev, curr);
  }

  return {
    items: items,
    mount: mount,
    destroy: destroy,
    getAt: getAt,
    update: update
  };
}

var TRIGGER_KEYS = [" ", "Enter"];

function Sync(Splide2, Components2, options) {
  var isNavigation = options.isNavigation,
      slideFocus = options.slideFocus;
  var events = [];

  function mount() {
    Splide2.splides.forEach(function (target) {
      if (!target.isParent) {
        sync(Splide2, target.splide);
        sync(target.splide, Splide2);
      }
    });

    if (isNavigation) {
      navigate();
    }
  }

  function destroy() {
    events.forEach(function (event) {
      event.destroy();
    });

    _get__("empty")(events);
  }

  function remount() {
    destroy();
    mount();
  }

  function sync(splide, target) {
    var event = _get__("EventInterface")(splide);

    event.on(_get__("EVENT_MOVE"), function (index, prev, dest) {
      target.go(target.is(_get__("LOOP")) ? dest : index);
    });
    events.push(event);
  }

  function navigate() {
    var event = _get__("EventInterface")(Splide2);

    var on = event.on;
    on(_get__("EVENT_CLICK"), onClick);
    on(_get__("EVENT_SLIDE_KEYDOWN"), onKeydown);
    on([_get__("EVENT_MOUNTED"), _get__("EVENT_UPDATED")], update);
    events.push(event);
    event.emit(_get__("EVENT_NAVIGATION_MOUNTED"), Splide2.splides);
  }

  function update() {
    _get__("setAttribute")(Components2.Elements.list, _get__("ARIA_ORIENTATION"), options.direction === _get__("TTB") ? "vertical" : "");
  }

  function onClick(Slide) {
    Splide2.go(Slide.index);
  }

  function onKeydown(Slide, e) {
    if (_get__("includes")(_get__("TRIGGER_KEYS"), _get__("normalizeKey")(e))) {
      onClick(Slide);

      _get__("prevent")(e);
    }
  }

  return {
    setup: _get__("apply")(Components2.Media.set, {
      slideFocus: _get__("isUndefined")(slideFocus) ? isNavigation : slideFocus
    }, true),
    mount: mount,
    destroy: destroy,
    remount: remount
  };
}

function Wheel(Splide2, Components2, options) {
  var _EventInterface12 = _get__("EventInterface")(Splide2),
      bind = _EventInterface12.bind;

  var lastTime = 0;

  function mount() {
    if (options.wheel) {
      bind(Components2.Elements.track, "wheel", onWheel, _get__("SCROLL_LISTENER_OPTIONS"));
    }
  }

  function onWheel(e) {
    if (e.cancelable) {
      var deltaY = e.deltaY;
      var backwards = deltaY < 0;

      var timeStamp = _get__("timeOf")(e);

      var _min = options.wheelMinThreshold || 0;

      var sleep = options.wheelSleep || 0;

      if (_get__("abs")(deltaY) > _min && timeStamp - lastTime > sleep) {
        Splide2.go(backwards ? "<" : ">");
        lastTime = timeStamp;
      }

      shouldPrevent(backwards) && _get__("prevent")(e);
    }
  }

  function shouldPrevent(backwards) {
    return !options.releaseWheel || Splide2.state.is(_get__("MOVING")) || Components2.Controller.getAdjacent(backwards) !== -1;
  }

  return {
    mount: mount
  };
}

var SR_REMOVAL_DELAY = 90;

function Live(Splide2, Components2, options) {
  var _EventInterface13 = _get__("EventInterface")(Splide2),
      on = _EventInterface13.on;

  var track = Components2.Elements.track;
  var enabled = options.live && !options.isNavigation;

  var sr = _get__("create")("span", _get__("CLASS_SR"));

  var interval = _get__("RequestInterval")(_get__("SR_REMOVAL_DELAY"), _get__("apply")(toggle, false));

  function mount() {
    if (enabled) {
      disable(!Components2.Autoplay.isPaused());

      _get__("setAttribute")(track, _get__("ARIA_ATOMIC"), true);

      sr.textContent = "\u2026";
      on(_get__("EVENT_AUTOPLAY_PLAY"), _get__("apply")(disable, true));
      on(_get__("EVENT_AUTOPLAY_PAUSE"), _get__("apply")(disable, false));
      on([_get__("EVENT_MOVED"), _get__("EVENT_SCROLLED")], _get__("apply")(toggle, true));
    }
  }

  function toggle(active) {
    _get__("setAttribute")(track, _get__("ARIA_BUSY"), active);

    if (active) {
      _get__("append")(track, sr);

      interval.start();
    } else {
      _get__("remove")(sr);

      interval.cancel();
    }
  }

  function destroy() {
    _get__("removeAttribute")(track, [_get__("ARIA_LIVE"), _get__("ARIA_ATOMIC"), _get__("ARIA_BUSY")]);

    _get__("remove")(sr);
  }

  function disable(disabled) {
    if (enabled) {
      _get__("setAttribute")(track, _get__("ARIA_LIVE"), disabled ? "off" : "polite");
    }
  }

  return {
    mount: mount,
    disable: disable,
    destroy: destroy
  };
}

var ComponentConstructors =
/*#__PURE__*/
Object.freeze({
  __proto__: null,
  Media: _get__("Media"),
  Direction: _get__("Direction"),
  Elements: _get__("Elements"),
  Slides: _get__("Slides"),
  Layout: _get__("Layout"),
  Clones: _get__("Clones"),
  Move: _get__("Move"),
  Controller: _get__("Controller"),
  Arrows: _get__("Arrows"),
  Autoplay: _get__("Autoplay"),
  Cover: _get__("Cover"),
  Scroll: _get__("Scroll"),
  Drag: _get__("Drag"),
  Keyboard: _get__("Keyboard"),
  LazyLoad: _get__("LazyLoad"),
  Pagination: _get__("Pagination"),
  Sync: _get__("Sync"),
  Wheel: _get__("Wheel"),
  Live: _get__("Live")
});
var I18N = {
  prev: "Previous slide",
  next: "Next slide",
  first: "Go to first slide",
  last: "Go to last slide",
  slideX: "Go to slide %s",
  pageX: "Go to page %s",
  play: "Start autoplay",
  pause: "Pause autoplay",
  carousel: "carousel",
  slide: "slide",
  select: "Select a slide to show",
  slideLabel: "%s of %s"
};
var DEFAULTS = {
  type: "slide",
  role: "region",
  speed: 400,
  perPage: 1,
  cloneStatus: true,
  arrows: true,
  pagination: true,
  paginationKeyboard: true,
  interval: 5e3,
  pauseOnHover: true,
  pauseOnFocus: true,
  resetProgress: true,
  easing: "cubic-bezier(0.25, 1, 0.5, 1)",
  drag: true,
  direction: "ltr",
  trimSpace: true,
  focusableNodes: "a, button, textarea, input, select, iframe",
  live: true,
  classes: _get__("CLASSES"),
  i18n: _get__("I18N"),
  reducedMotion: {
    speed: 0,
    rewindSpeed: 0,
    autoplay: "pause"
  }
};

function Fade(Splide2, Components2, options) {
  var Slides = Components2.Slides;

  function mount() {
    _get__("EventInterface")(Splide2).on([_get__("EVENT_MOUNTED"), _get__("EVENT_REFRESH")], init);
  }

  function init() {
    Slides.forEach(function (Slide) {
      Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
    });
  }

  function start(index, done) {
    Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);

    _get__("nextTick")(done);
  }

  return {
    mount: mount,
    start: start,
    cancel: _get__("noop")
  };
}

function Slide(Splide2, Components2, options) {
  var Move = Components2.Move,
      Controller = Components2.Controller,
      Scroll = Components2.Scroll;
  var list = Components2.Elements.list;

  var transition = _get__("apply")(_get__("style"), list, "transition");

  var endCallback;

  function mount() {
    _get__("EventInterface")(Splide2).bind(list, "transitionend", function (e) {
      if (e.target === list && endCallback) {
        cancel();
        endCallback();
      }
    });
  }

  function start(index, done) {
    var destination = Move.toPosition(index, true);
    var position = Move.getPosition();
    var speed = getSpeed(index);

    if (_get__("abs")(destination - position) >= 1 && speed >= 1) {
      if (options.useScroll) {
        Scroll.scroll(destination, speed, false, done);
      } else {
        transition("transform " + speed + "ms " + options.easing);
        Move.translate(destination, true);
        endCallback = done;
      }
    } else {
      Move.jump(index);
      done();
    }
  }

  function cancel() {
    transition("");
    Scroll.cancel();
  }

  function getSpeed(index) {
    var rewindSpeed = options.rewindSpeed;

    if (Splide2.is(_get__("SLIDE")) && rewindSpeed) {
      var prev = Controller.getIndex(true);
      var end = Controller.getEnd();

      if (prev === 0 && index >= end || prev >= end && index === 0) {
        return rewindSpeed;
      }
    }

    return options.speed;
  }

  return {
    mount: mount,
    start: start,
    cancel: cancel
  };
}

var _Splide =
/*#__PURE__*/
function () {
  function _Splide(target, options) {
    this.event = _get__("EventInterface")();
    this.Components = {};
    this.state = _get__("State")(_get__("CREATED"));
    this.splides = [];
    this._o = {};
    this._E = {};
    var root = _get__("isString")(target) ? _get__("query")(document, target) : target;

    _get__("assert")(root, root + " is invalid.");

    this.root = root;
    options = _get__("merge")({
      label: _get__("getAttribute")(root, _get__("ARIA_LABEL")) || "",
      labelledby: _get__("getAttribute")(root, _get__("ARIA_LABELLEDBY")) || ""
    }, _get__("DEFAULTS"), _Splide.defaults, options || {});

    try {
      _get__("merge")(options, JSON.parse(_get__("getAttribute")(root, _get__("DATA_ATTRIBUTE"))));
    } catch (e) {
      _get__("assert")(false, "Invalid JSON");
    }

    this._o = Object.create(_get__("merge")({}, options));
  }

  var _proto = _Splide.prototype;

  _proto.mount = function mount(Extensions, Transition) {
    var _this = this;

    var state = this.state,
        Components2 = this.Components;

    _get__("assert")(state.is([_get__("CREATED"), _get__("DESTROYED")]), "Already mounted!");

    state.set(_get__("CREATED"));
    this._C = Components2;
    this._T = Transition || this._T || (this.is(_get__("FADE")) ? _get__("Fade") : _get__("Slide"));
    this._E = Extensions || this._E;

    var Constructors = _get__("assign")({}, _get__("ComponentConstructors"), this._E, {
      Transition: this._T
    });

    _get__("forOwn")(Constructors, function (Component, key) {
      var component = Component(_this, Components2, _this._o);
      Components2[key] = component;
      component.setup && component.setup();
    });

    _get__("forOwn")(Components2, function (component) {
      component.mount && component.mount();
    });

    this.emit(_get__("EVENT_MOUNTED"));

    _get__("addClass")(this.root, _get__("CLASS_INITIALIZED"));

    state.set(_get__("IDLE"));
    this.emit(_get__("EVENT_READY"));
    return this;
  };

  _proto.sync = function sync(splide) {
    this.splides.push({
      splide: splide
    });
    splide.splides.push({
      splide: this,
      isParent: true
    });

    if (this.state.is(_get__("IDLE"))) {
      this._C.Sync.remount();

      splide.Components.Sync.remount();
    }

    return this;
  };

  _proto.go = function go(control) {
    this._C.Controller.go(control);

    return this;
  };

  _proto.on = function on(events, callback) {
    this.event.on(events, callback);
    return this;
  };

  _proto.off = function off(events) {
    this.event.off(events);
    return this;
  };

  _proto.emit = function emit(event) {
    var _this$event;

    (_this$event = this.event).emit.apply(_this$event, [event].concat(_get__("slice")(arguments, 1)));

    return this;
  };

  _proto.add = function add(slides, index) {
    this._C.Slides.add(slides, index);

    return this;
  };

  _proto.remove = function remove(matcher) {
    this._C.Slides.remove(matcher);

    return this;
  };

  _proto.is = function is(type) {
    return this._o.type === type;
  };

  _proto.refresh = function refresh() {
    this.emit(_get__("EVENT_REFRESH"));
    return this;
  };

  _proto.destroy = function destroy(completely) {
    if (completely === void 0) {
      completely = true;
    }

    var event = this.event,
        state = this.state;

    if (state.is(_get__("CREATED"))) {
      _get__("EventInterface")(this).on(_get__("EVENT_READY"), this.destroy.bind(this, completely));
    } else {
      _get__("forOwn")(this._C, function (component) {
        component.destroy && component.destroy(completely);
      }, true);

      event.emit(_get__("EVENT_DESTROY"));
      event.destroy();
      completely && _get__("empty")(this.splides);
      state.set(_get__("DESTROYED"));
    }

    return this;
  };

  _get__("_createClass")(_Splide, [{
    key: "options",
    get: function get() {
      return this._o;
    },
    set: function set(options) {
      this._C.Media.set(options, true, true);
    }
  }, {
    key: "length",
    get: function get() {
      return this._C.Slides.getLength(true);
    }
  }, {
    key: "index",
    get: function get() {
      return this._C.Controller.getIndex();
    }
  }]);

  return _Splide;
}();

var Splide = _get__("_Splide");

_get__("Splide").defaults = {};
_get__("Splide").STATES = _get__("STATES");
var CLASS_RENDERED = "is-rendered";
var RENDERER_DEFAULT_CONFIG = {
  listTag: "ul",
  slideTag: "li"
};

var Style =
/*#__PURE__*/
function () {
  function Style(id, options) {
    this.styles = {};
    this.id = id;
    this.options = options;
  }

  var _proto2 = Style.prototype;

  _proto2.rule = function rule(selector, prop, value, breakpoint) {
    breakpoint = breakpoint || "default";
    var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
    var styles = selectors[selector] = selectors[selector] || {};
    styles[prop] = value;
  };

  _proto2.build = function build() {
    var _this2 = this;

    var css = "";

    if (this.styles["default"]) {
      css += this.buildSelectors(this.styles["default"]);
    }

    Object.keys(this.styles).sort(function (n, m) {
      return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
    }).forEach(function (breakpoint) {
      if (breakpoint !== "default") {
        css += "@media screen and (max-width: " + breakpoint + "px) {";
        css += _this2.buildSelectors(_this2.styles[breakpoint]);
        css += "}";
      }
    });
    return css;
  };

  _proto2.buildSelectors = function buildSelectors(selectors) {
    var _this3 = this;

    var css = "";

    _get__("forOwn")(selectors, function (styles, selector) {
      selector = ("#" + _this3.id + " " + selector).trim();
      css += selector + " {";

      _get__("forOwn")(styles, function (value, prop) {
        if (value || value === 0) {
          css += prop + ": " + value + ";";
        }
      });

      css += "}";
    });

    return css;
  };

  return Style;
}();

var SplideRenderer =
/*#__PURE__*/
function () {
  function SplideRenderer(contents, options, config, defaults) {
    this.slides = [];
    this.options = {};
    this.breakpoints = [];

    _get__("merge")(_get__("DEFAULTS"), defaults || {});

    _get__("merge")(_get__("merge")(this.options, _get__("DEFAULTS")), options || {});

    this.contents = contents;
    this.config = _get__("assign")({}, _get__("RENDERER_DEFAULT_CONFIG"), config || {});
    this.id = this.config.id || _get__("uniqueId")("splide");
    this.Style = new (_get__("Style"))(this.id, this.options);
    this.Direction = _get__("Direction")(null, null, this.options);

    _get__("assert")(this.contents.length, "Provide at least 1 content.");

    this.init();
  }

  SplideRenderer.clean = function clean(splide) {
    var _EventInterface14 = _get__("EventInterface")(splide),
        on = _EventInterface14.on;

    var root = splide.root;

    var clones = _get__("queryAll")(root, "." + _get__("CLASS_CLONE"));

    on(_get__("EVENT_MOUNTED"), function () {
      _get__("remove")(_get__("child")(root, "style"));
    });

    _get__("remove")(clones);
  };

  var _proto3 = SplideRenderer.prototype;

  _proto3.init = function init() {
    this.parseBreakpoints();
    this.initSlides();
    this.registerRootStyles();
    this.registerTrackStyles();
    this.registerSlideStyles();
    this.registerListStyles();
  };

  _proto3.initSlides = function initSlides() {
    var _this4 = this;

    _get__("push")(this.slides, this.contents.map(function (content, index) {
      content = _get__("isString")(content) ? {
        html: content
      } : content;
      content.styles = content.styles || {};
      content.attrs = content.attrs || {};

      _this4.cover(content);

      var classes = _this4.options.classes.slide + " " + (index === 0 ? _get__("CLASS_ACTIVE") : "");

      _get__("assign")(content.attrs, {
        "class": (classes + " " + (content.attrs["class"] || "")).trim(),
        style: _this4.buildStyles(content.styles)
      });

      return content;
    }));

    if (this.isLoop()) {
      this.generateClones(this.slides);
    }
  };

  _proto3.registerRootStyles = function registerRootStyles() {
    var _this5 = this;

    this.breakpoints.forEach(function (_ref2) {
      var width = _ref2[0],
          options = _ref2[1];

      _this5.Style.rule(" ", "max-width", _get__("unit")(options.width), width);
    });
  };

  _proto3.registerTrackStyles = function registerTrackStyles() {
    var _this6 = this;

    var Style2 = this.Style;

    var selector = "." + _get__("CLASS_TRACK");

    this.breakpoints.forEach(function (_ref3) {
      var width = _ref3[0],
          options = _ref3[1];
      Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
      Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
      Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
    });
  };

  _proto3.registerListStyles = function registerListStyles() {
    var _this7 = this;

    var Style2 = this.Style;

    var selector = "." + _get__("CLASS_LIST");

    this.breakpoints.forEach(function (_ref4) {
      var width = _ref4[0],
          options = _ref4[1];
      Style2.rule(selector, "transform", _this7.buildTranslate(options), width);

      if (!_this7.cssSlideHeight(options)) {
        Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
      }
    });
  };

  _proto3.registerSlideStyles = function registerSlideStyles() {
    var _this8 = this;

    var Style2 = this.Style;

    var selector = "." + _get__("CLASS_SLIDE");

    this.breakpoints.forEach(function (_ref5) {
      var width = _ref5[0],
          options = _ref5[1];
      Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
      Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
      Style2.rule(selector, _this8.resolve("marginRight"), _get__("unit")(options.gap) || "0px", width);
      Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
    });
  };

  _proto3.buildTranslate = function buildTranslate(options) {
    var _this$Direction = this.Direction,
        resolve = _this$Direction.resolve,
        orient = _this$Direction.orient;
    var values = [];
    values.push(this.cssOffsetClones(options));
    values.push(this.cssOffsetGaps(options));

    if (this.isCenter(options)) {
      values.push(this.buildCssValue(orient(-50), "%"));
      values.push.apply(values, this.cssOffsetCenter(options));
    }

    return values.filter(Boolean).map(function (value) {
      return "translate" + resolve("X") + "(" + value + ")";
    }).join(" ");
  };

  _proto3.cssOffsetClones = function cssOffsetClones(options) {
    var _this$Direction2 = this.Direction,
        resolve = _this$Direction2.resolve,
        orient = _this$Direction2.orient;
    var cloneCount = this.getCloneCount();

    if (this.isFixedWidth(options)) {
      var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]),
          value = _this$parseCssValue.value,
          unit2 = _this$parseCssValue.unit;

      return this.buildCssValue(orient(value) * cloneCount, unit2);
    }

    var percent = 100 * cloneCount / options.perPage;
    return orient(percent) + "%";
  };

  _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
    var _this$Direction3 = this.Direction,
        resolve = _this$Direction3.resolve,
        orient = _this$Direction3.orient;

    if (this.isFixedWidth(options)) {
      var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]),
          value = _this$parseCssValue2.value,
          unit2 = _this$parseCssValue2.unit;

      return [this.buildCssValue(orient(value / 2), unit2)];
    }

    var values = [];
    var perPage = options.perPage,
        gap = options.gap;
    values.push(orient(50 / perPage) + "%");

    if (gap) {
      var _this$parseCssValue3 = this.parseCssValue(gap),
          _value = _this$parseCssValue3.value,
          _unit = _this$parseCssValue3.unit;

      var gapOffset = (_value / perPage - _value) / 2;
      values.push(this.buildCssValue(orient(gapOffset), _unit));
    }

    return values;
  };

  _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
    var cloneCount = this.getCloneCount();

    if (cloneCount && options.gap) {
      var orient = this.Direction.orient;

      var _this$parseCssValue4 = this.parseCssValue(options.gap),
          value = _this$parseCssValue4.value,
          unit2 = _this$parseCssValue4.unit;

      if (this.isFixedWidth(options)) {
        return this.buildCssValue(orient(value * cloneCount), unit2);
      }

      var perPage = options.perPage;
      var gaps = cloneCount / perPage;
      return this.buildCssValue(orient(gaps * value), unit2);
    }

    return "";
  };

  _proto3.resolve = function resolve(prop) {
    return _get__("camelToKebab")(this.Direction.resolve(prop));
  };

  _proto3.cssPadding = function cssPadding(options, right) {
    var padding = options.padding;
    var prop = this.Direction.resolve(right ? "right" : "left", true);
    return padding && _get__("unit")(padding[prop] || (_get__("isObject")(padding) ? 0 : padding)) || "0px";
  };

  _proto3.cssTrackHeight = function cssTrackHeight(options) {
    var height = "";

    if (this.isVertical()) {
      height = this.cssHeight(options);

      _get__("assert")(height, '"height" is missing.');

      height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
    }

    return height;
  };

  _proto3.cssHeight = function cssHeight(options) {
    return _get__("unit")(options.height);
  };

  _proto3.cssSlideWidth = function cssSlideWidth(options) {
    return options.autoWidth ? "" : _get__("unit")(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
  };

  _proto3.cssSlideHeight = function cssSlideHeight(options) {
    return _get__("unit")(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
  };

  _proto3.cssSlideSize = function cssSlideSize(options) {
    var gap = _get__("unit")(options.gap);

    return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
  };

  _proto3.cssAspectRatio = function cssAspectRatio(options) {
    var heightRatio = options.heightRatio;
    return heightRatio ? "" + 1 / heightRatio : "";
  };

  _proto3.buildCssValue = function buildCssValue(value, unit2) {
    return "" + value + unit2;
  };

  _proto3.parseCssValue = function parseCssValue(value) {
    if (_get__("isString")(value)) {
      var number = parseFloat(value) || 0;
      var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
      return {
        value: number,
        unit: unit2
      };
    }

    return {
      value: value,
      unit: "px"
    };
  };

  _proto3.parseBreakpoints = function parseBreakpoints() {
    var _this9 = this;

    var breakpoints = this.options.breakpoints;
    this.breakpoints.push(["default", this.options]);

    if (breakpoints) {
      _get__("forOwn")(breakpoints, function (options, width) {
        _this9.breakpoints.push([width, _get__("merge")(_get__("merge")({}, _this9.options), options)]);
      });
    }
  };

  _proto3.isFixedWidth = function isFixedWidth(options) {
    return !!options[this.Direction.resolve("fixedWidth")];
  };

  _proto3.isLoop = function isLoop() {
    return this.options.type === _get__("LOOP");
  };

  _proto3.isCenter = function isCenter(options) {
    if (options.focus === "center") {
      if (this.isLoop()) {
        return true;
      }

      if (this.options.type === _get__("SLIDE")) {
        return !this.options.trimSpace;
      }
    }

    return false;
  };

  _proto3.isVertical = function isVertical() {
    return this.options.direction === _get__("TTB");
  };

  _proto3.buildClasses = function buildClasses() {
    var options = this.options;
    return [_get__("CLASS_ROOT"), _get__("CLASS_ROOT") + "--" + options.type, _get__("CLASS_ROOT") + "--" + options.direction, options.drag && _get__("CLASS_ROOT") + "--draggable", options.isNavigation && _get__("CLASS_ROOT") + "--nav", _get__("CLASS_ACTIVE"), !this.config.hidden && _get__("CLASS_RENDERED")].filter(Boolean).join(" ");
  };

  _proto3.buildAttrs = function buildAttrs(attrs) {
    var attr = "";

    _get__("forOwn")(attrs, function (value, key) {
      attr += value ? " " + _get__("camelToKebab")(key) + "=\"" + value + "\"" : "";
    });

    return attr.trim();
  };

  _proto3.buildStyles = function buildStyles(styles) {
    var style = "";

    _get__("forOwn")(styles, function (value, key) {
      style += " " + _get__("camelToKebab")(key) + ":" + value + ";";
    });

    return style.trim();
  };

  _proto3.renderSlides = function renderSlides() {
    var _this10 = this;

    var tag = this.config.slideTag;
    return this.slides.map(function (content) {
      return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
    }).join("");
  };

  _proto3.cover = function cover(content) {
    var styles = content.styles,
        _content$html = content.html,
        html = _content$html === void 0 ? "" : _content$html;

    if (this.options.cover && !this.options.lazyLoad) {
      var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);

      if (src && src[2]) {
        styles.background = "center/cover no-repeat url('" + src[2] + "')";
      }
    }
  };

  _proto3.generateClones = function generateClones(contents) {
    var classes = this.options.classes;
    var count = this.getCloneCount();
    var slides = contents.slice();

    while (slides.length < count) {
      _get__("push")(slides, slides);
    }

    _get__("push")(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function (content, index) {
      var attrs = _get__("assign")({}, content.attrs, {
        "class": content.attrs["class"] + " " + classes.clone
      });

      var clone = _get__("assign")({}, content, {
        attrs: attrs
      });

      index < count ? contents.unshift(clone) : contents.push(clone);
    });
  };

  _proto3.getCloneCount = function getCloneCount() {
    if (this.isLoop()) {
      var options = this.options;

      if (options.clones) {
        return options.clones;
      }

      var perPage = _get__("max").apply(void 0, this.breakpoints.map(function (_ref6) {
        var options2 = _ref6[1];
        return options2.perPage;
      }));

      return perPage * ((options.flickMaxPages || 1) + 1);
    }

    return 0;
  };

  _proto3.renderArrows = function renderArrows() {
    var html = "";
    html += "<div class=\"" + this.options.classes.arrows + "\">";
    html += this.renderArrow(true);
    html += this.renderArrow(false);
    html += "</div>";
    return html;
  };

  _proto3.renderArrow = function renderArrow(prev) {
    var _this$options = this.options,
        classes = _this$options.classes,
        i18n = _this$options.i18n;
    var attrs = {
      "class": classes.arrow + " " + (prev ? classes.prev : classes.next),
      type: "button",
      ariaLabel: prev ? i18n.prev : i18n.next
    };
    return "<button " + this.buildAttrs(attrs) + "><svg xmlns=\"" + _get__("XML_NAME_SPACE") + "\" viewBox=\"0 0 " + _get__("SIZE") + " " + _get__("SIZE") + "\" width=\"" + _get__("SIZE") + "\" height=\"" + _get__("SIZE") + "\"><path d=\"" + (this.options.arrowPath || _get__("PATH")) + "\" /></svg></button>";
  };

  _proto3.html = function html() {
    var _this$config = this.config,
        rootClass = _this$config.rootClass,
        listTag = _this$config.listTag,
        arrows = _this$config.arrows,
        beforeTrack = _this$config.beforeTrack,
        afterTrack = _this$config.afterTrack,
        slider = _this$config.slider,
        beforeSlider = _this$config.beforeSlider,
        afterSlider = _this$config.afterSlider;
    var html = "";
    html += "<div id=\"" + this.id + "\" class=\"" + this.buildClasses() + " " + (rootClass || "") + "\">";
    html += "<style>" + this.Style.build() + "</style>";

    if (slider) {
      html += beforeSlider || "";
      html += "<div class=\"splide__slider\">";
    }

    html += beforeTrack || "";

    if (arrows) {
      html += this.renderArrows();
    }

    html += "<div class=\"splide__track\">";
    html += "<" + listTag + " class=\"splide__list\">";
    html += this.renderSlides();
    html += "</" + listTag + ">";
    html += "</div>";
    html += afterTrack || "";

    if (slider) {
      html += "</div>";
      html += afterSlider || "";
    }

    html += "</div>";
    return html;
  };

  return SplideRenderer;
}();

export { CLASSES, CLASS_ACTIVE, CLASS_ARROW, CLASS_ARROWS, CLASS_ARROW_NEXT, CLASS_ARROW_PREV, CLASS_CLONE, CLASS_CONTAINER, CLASS_FOCUS_IN, CLASS_INITIALIZED, CLASS_LIST, CLASS_LOADING, CLASS_NEXT, CLASS_OVERFLOW, CLASS_PAGINATION, CLASS_PAGINATION_PAGE, CLASS_PREV, CLASS_PROGRESS, CLASS_PROGRESS_BAR, CLASS_ROOT, CLASS_SLIDE, CLASS_SPINNER, CLASS_SR, CLASS_TOGGLE, CLASS_TOGGLE_PAUSE, CLASS_TOGGLE_PLAY, CLASS_TRACK, CLASS_VISIBLE, DEFAULTS, EVENT_ACTIVE, EVENT_ARROWS_MOUNTED, EVENT_ARROWS_UPDATED, EVENT_AUTOPLAY_PAUSE, EVENT_AUTOPLAY_PLAY, EVENT_AUTOPLAY_PLAYING, EVENT_CLICK, EVENT_DESTROY, EVENT_DRAG, EVENT_DRAGGED, EVENT_DRAGGING, EVENT_END_INDEX_CHANGED, EVENT_HIDDEN, EVENT_INACTIVE, EVENT_LAZYLOAD_LOADED, EVENT_MOUNTED, EVENT_MOVE, EVENT_MOVED, EVENT_NAVIGATION_MOUNTED, EVENT_OVERFLOW, EVENT_PAGINATION_MOUNTED, EVENT_PAGINATION_UPDATED, EVENT_READY, EVENT_REFRESH, EVENT_RESIZE, EVENT_RESIZED, EVENT_SCROLL, EVENT_SCROLLED, EVENT_SHIFTED, EVENT_SLIDE_KEYDOWN, EVENT_UPDATED, EVENT_VISIBLE, EventBinder, EventInterface, FADE, LOOP, LTR, RTL, RequestInterval, SLIDE, STATUS_CLASSES, Splide, SplideRenderer, State, TTB, Throttle, Splide as default };

function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}

;
var _RewireModuleId__ = null;

function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();

    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }

    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }

  return _RewireModuleId__;
}

function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }

  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}

function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();

  var registry = _getRewireRegistry__();

  var rewireData = registry[moduleId];

  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }

  return rewireData;
}

(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();

  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();

var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};

(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }

  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();

function _get__(variableName) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];

    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}

function _get_original__(variableName) {
  switch (variableName) {
    case "_defineProperties":
      return _defineProperties;

    case "CREATED":
      return CREATED;

    case "MOUNTED":
      return MOUNTED;

    case "IDLE":
      return IDLE;

    case "MOVING":
      return MOVING;

    case "SCROLLING":
      return SCROLLING;

    case "DRAGGING":
      return DRAGGING;

    case "DESTROYED":
      return DESTROYED;

    case "slice":
      return slice;

    case "isNull":
      return isNull;

    case "typeOf":
      return typeOf;

    case "apply":
      return apply;

    case "isArray":
      return isArray;

    case "toArray":
      return toArray;

    case "forEach":
      return forEach;

    case "toggleClass":
      return toggleClass;

    case "isString":
      return isString;

    case "isHTMLElement":
      return isHTMLElement;

    case "matches":
      return matches;

    case "children":
      return children;

    case "ownKeys":
      return ownKeys;

    case "forOwn":
      return forOwn;

    case "isObject":
      return isObject;

    case "merge":
      return merge;

    case "setAttribute":
      return setAttribute;

    case "removeAttribute":
      return removeAttribute;

    case "addClass":
      return addClass;

    case "append":
      return append;

    case "isUndefined":
      return isUndefined;

    case "style":
      return style;

    case "child":
      return child;

    case "PROJECT_CODE":
      return PROJECT_CODE;

    case "abs":
      return abs;

    case "min":
      return min;

    case "max":
      return max;

    case "pad":
      return pad;

    case "ids":
      return ids;

    case "empty":
      return empty;

    case "EventBinder":
      return EventBinder;

    case "EVENT_DESTROY":
      return EVENT_DESTROY;

    case "assign":
      return assign;

    case "raf":
      return raf;

    case "includes":
      return includes;

    case "RequestInterval":
      return RequestInterval;

    case "MEDIA_PREFERS_REDUCED_MOTION":
      return MEDIA_PREFERS_REDUCED_MOTION;

    case "omit":
      return omit;

    case "EVENT_UPDATED":
      return EVENT_UPDATED;

    case "ARROW":
      return ARROW;

    case "ARROW_UP":
      return ARROW_UP;

    case "ARROW_RIGHT":
      return ARROW_RIGHT;

    case "ARROW_DOWN":
      return ARROW_DOWN;

    case "ARROW_LEFT":
      return ARROW_LEFT;

    case "RTL":
      return RTL;

    case "TTB":
      return TTB;

    case "ORIENTATION_MAP":
      return ORIENTATION_MAP;

    case "ARIA_PREFIX":
      return ARIA_PREFIX;

    case "ROLE":
      return ROLE;

    case "TAB_INDEX":
      return TAB_INDEX;

    case "DISABLED":
      return DISABLED;

    case "ARIA_CONTROLS":
      return ARIA_CONTROLS;

    case "ARIA_CURRENT":
      return ARIA_CURRENT;

    case "ARIA_LABEL":
      return ARIA_LABEL;

    case "ARIA_LABELLEDBY":
      return ARIA_LABELLEDBY;

    case "ARIA_HIDDEN":
      return ARIA_HIDDEN;

    case "ARIA_ORIENTATION":
      return ARIA_ORIENTATION;

    case "ARIA_ROLEDESCRIPTION":
      return ARIA_ROLEDESCRIPTION;

    case "CLASS_PREFIX":
      return CLASS_PREFIX;

    case "CLASS_SLIDE":
      return CLASS_SLIDE;

    case "CLASS_ARROW":
      return CLASS_ARROW;

    case "CLASS_PAGINATION":
      return CLASS_PAGINATION;

    case "CLASS_PROGRESS":
      return CLASS_PROGRESS;

    case "CLASS_TOGGLE":
      return CLASS_TOGGLE;

    case "STATUS_CLASS_PREFIX":
      return STATUS_CLASS_PREFIX;

    case "CLASS_ACTIVE":
      return CLASS_ACTIVE;

    case "CLASS_VISIBLE":
      return CLASS_VISIBLE;

    case "CLASS_PREV":
      return CLASS_PREV;

    case "CLASS_NEXT":
      return CLASS_NEXT;

    case "CLASS_LOADING":
      return CLASS_LOADING;

    case "CLASS_FOCUS_IN":
      return CLASS_FOCUS_IN;

    case "CLASS_OVERFLOW":
      return CLASS_OVERFLOW;

    case "CLASS_CLONE":
      return CLASS_CLONE;

    case "CLASS_ARROWS":
      return CLASS_ARROWS;

    case "CLASS_ARROW_PREV":
      return CLASS_ARROW_PREV;

    case "CLASS_ARROW_NEXT":
      return CLASS_ARROW_NEXT;

    case "CLASS_PAGINATION_PAGE":
      return CLASS_PAGINATION_PAGE;

    case "CLASS_SPINNER":
      return CLASS_SPINNER;

    case "isFunction":
      return isFunction;

    case "EventInterface":
      return EventInterface;

    case "EVENT_REFRESH":
      return EVENT_REFRESH;

    case "POINTER_DOWN_EVENTS":
      return POINTER_DOWN_EVENTS;

    case "ALL_ATTRIBUTES":
      return ALL_ATTRIBUTES;

    case "removeClass":
      return removeClass;

    case "CLASS_ROOT":
      return CLASS_ROOT;

    case "CLASS_TRACK":
      return CLASS_TRACK;

    case "CLASS_LIST":
      return CLASS_LIST;

    case "assert":
      return assert;

    case "push":
      return push;

    case "CLASS_PROGRESS_BAR":
      return CLASS_PROGRESS_BAR;

    case "uniqueId":
      return uniqueId;

    case "getAttribute":
      return getAttribute;

    case "query":
      return query;

    case "closest":
      return closest;

    case "CLASS_CONTAINER":
      return CLASS_CONTAINER;

    case "format":
      return format;

    case "EVENT_CLICK":
      return EVENT_CLICK;

    case "EVENT_SLIDE_KEYDOWN":
      return EVENT_SLIDE_KEYDOWN;

    case "EVENT_MOVED":
      return EVENT_MOVED;

    case "EVENT_SHIFTED":
      return EVENT_SHIFTED;

    case "EVENT_SCROLLED":
      return EVENT_SCROLLED;

    case "EVENT_NAVIGATION_MOUNTED":
      return EVENT_NAVIGATION_MOUNTED;

    case "EVENT_MOVE":
      return EVENT_MOVE;

    case "STATUS_CLASSES":
      return STATUS_CLASSES;

    case "hasClass":
      return hasClass;

    case "EVENT_ACTIVE":
      return EVENT_ACTIVE;

    case "EVENT_INACTIVE":
      return EVENT_INACTIVE;

    case "queryAll":
      return queryAll;

    case "EVENT_VISIBLE":
      return EVENT_VISIBLE;

    case "EVENT_HIDDEN":
      return EVENT_HIDDEN;

    case "focus":
      return focus;

    case "FADE":
      return FADE;

    case "rect":
      return rect;

    case "floor":
      return floor;

    case "ceil":
      return ceil;

    case "LOOP":
      return LOOP;

    case "Slide$1":
      return Slide$1;

    case "between":
      return between;

    case "parseHtml":
      return parseHtml;

    case "before":
      return before;

    case "EVENT_RESIZE":
      return EVENT_RESIZE;

    case "remove":
      return remove;

    case "Throttle":
      return Throttle;

    case "unit":
      return unit;

    case "EVENT_RESIZED":
      return EVENT_RESIZED;

    case "EVENT_OVERFLOW":
      return EVENT_OVERFLOW;

    case "MULTIPLIER":
      return MULTIPLIER;

    case "EVENT_MOUNTED":
      return EVENT_MOUNTED;

    case "SLIDE":
      return SLIDE;

    case "clamp":
      return clamp;

    case "EVENT_END_INDEX_CHANGED":
      return EVENT_END_INDEX_CHANGED;

    case "approximatelyEqual":
      return approximatelyEqual;

    case "display":
      return display;

    case "EVENT_ARROWS_MOUNTED":
      return EVENT_ARROWS_MOUNTED;

    case "create":
      return create;

    case "XML_NAME_SPACE":
      return XML_NAME_SPACE;

    case "SIZE":
      return SIZE;

    case "PATH":
      return PATH;

    case "EVENT_ARROWS_UPDATED":
      return EVENT_ARROWS_UPDATED;

    case "DATA_ATTRIBUTE":
      return DATA_ATTRIBUTE;

    case "EVENT_SCROLL":
      return EVENT_SCROLL;

    case "EVENT_AUTOPLAY_PLAY":
      return EVENT_AUTOPLAY_PLAY;

    case "EVENT_AUTOPLAY_PAUSE":
      return EVENT_AUTOPLAY_PAUSE;

    case "EVENT_AUTOPLAY_PLAYING":
      return EVENT_AUTOPLAY_PLAYING;

    case "INTERVAL_DATA_ATTRIBUTE":
      return INTERVAL_DATA_ATTRIBUTE;

    case "EVENT_LAZYLOAD_LOADED":
      return EVENT_LAZYLOAD_LOADED;

    case "sign":
      return sign;

    case "BASE_VELOCITY":
      return BASE_VELOCITY;

    case "MIN_DURATION":
      return MIN_DURATION;

    case "FRICTION_FACTOR":
      return FRICTION_FACTOR;

    case "BOUNCE_DIFF_THRESHOLD":
      return BOUNCE_DIFF_THRESHOLD;

    case "BOUNCE_DURATION":
      return BOUNCE_DURATION;

    case "POINTER_MOVE_EVENTS":
      return POINTER_MOVE_EVENTS;

    case "noop":
      return noop;

    case "SCROLL_LISTENER_OPTIONS":
      return SCROLL_LISTENER_OPTIONS;

    case "POINTER_UP_EVENTS":
      return POINTER_UP_EVENTS;

    case "prevent":
      return prevent;

    case "EVENT_DRAG":
      return EVENT_DRAG;

    case "LOG_INTERVAL":
      return LOG_INTERVAL;

    case "EVENT_DRAGGING":
      return EVENT_DRAGGING;

    case "EVENT_DRAGGED":
      return EVENT_DRAGGED;

    case "timeOf":
      return timeOf;

    case "FRICTION":
      return FRICTION;

    case "NORMALIZATION_MAP":
      return NORMALIZATION_MAP;

    case "KEYBOARD_EVENT":
      return KEYBOARD_EVENT;

    case "nextTick":
      return nextTick;

    case "normalizeKey":
      return normalizeKey;

    case "SRC_DATA_ATTRIBUTE":
      return SRC_DATA_ATTRIBUTE;

    case "SRCSET_DATA_ATTRIBUTE":
      return SRCSET_DATA_ATTRIBUTE;

    case "IMAGE_SELECTOR":
      return IMAGE_SELECTOR;

    case "EVENT_PAGINATION_MOUNTED":
      return EVENT_PAGINATION_MOUNTED;

    case "ARIA_SELECTED":
      return ARIA_SELECTED;

    case "EVENT_PAGINATION_UPDATED":
      return EVENT_PAGINATION_UPDATED;

    case "TRIGGER_KEYS":
      return TRIGGER_KEYS;

    case "CLASS_SR":
      return CLASS_SR;

    case "SR_REMOVAL_DELAY":
      return SR_REMOVAL_DELAY;

    case "ARIA_ATOMIC":
      return ARIA_ATOMIC;

    case "ARIA_BUSY":
      return ARIA_BUSY;

    case "ARIA_LIVE":
      return ARIA_LIVE;

    case "Media":
      return Media;

    case "Direction":
      return Direction;

    case "Elements":
      return Elements;

    case "Slides":
      return Slides;

    case "Layout":
      return Layout;

    case "Clones":
      return Clones;

    case "Move":
      return Move;

    case "Controller":
      return Controller;

    case "Arrows":
      return Arrows;

    case "Autoplay":
      return Autoplay;

    case "Cover":
      return Cover;

    case "Scroll":
      return Scroll;

    case "Drag":
      return Drag;

    case "Keyboard":
      return Keyboard;

    case "LazyLoad":
      return LazyLoad;

    case "Pagination":
      return Pagination;

    case "Sync":
      return Sync;

    case "Wheel":
      return Wheel;

    case "Live":
      return Live;

    case "CLASSES":
      return CLASSES;

    case "I18N":
      return I18N;

    case "State":
      return State;

    case "DEFAULTS":
      return DEFAULTS;

    case "Fade":
      return Fade;

    case "Slide":
      return Slide;

    case "ComponentConstructors":
      return ComponentConstructors;

    case "CLASS_INITIALIZED":
      return CLASS_INITIALIZED;

    case "EVENT_READY":
      return EVENT_READY;

    case "_createClass":
      return _createClass;

    case "_Splide":
      return _Splide;

    case "Splide":
      return Splide;

    case "STATES":
      return STATES;

    case "RENDERER_DEFAULT_CONFIG":
      return RENDERER_DEFAULT_CONFIG;

    case "Style":
      return Style;

    case "camelToKebab":
      return camelToKebab;

    case "CLASS_RENDERED":
      return CLASS_RENDERED;
  }

  return undefined;
}

function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}

function _set_original__(variableName, _value2) {
  switch (variableName) {}

  return undefined;
}

function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);

  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;

  _assign__(variableName, newValue);

  return prefix ? newValue : oldValue;
}

function _set__(variableName, value) {
  var rewireData = _getRewiredData__();

  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }

    return function () {
      _reset__(variableName);
    };
  }
}

function _reset__(variableName) {
  var rewireData = _getRewiredData__();

  delete rewireData[variableName];

  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }

  ;
}

function _with__(object) {
  var rewireData = _getRewiredData__();

  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};

  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }

  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();

    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }

    return result;
  };
}

export { _get__ as __get__, _get__ as __GetDependency__, _set__ as __Rewire__, _set__ as __set__, _reset__ as __ResetDependency__, _RewireAPI__ as __RewireAPI__ };